webpackJsonp([1,2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/* exports provided: default */
/* exports used: default */
/*!*****************************************!*\
  !*** ./client/utilities/toneUtility.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  synthDefaults: {
    Synth: {
      detune: 0,
      volume: 0,
      portamento: 0,
      oscillator: {
        type: 'sine'
      },
      envelope: {
        attack: 0.005,
        attackCurve: 'linear',
        decay: 0.1,
        sustain: 0.9,
        release: 1,
        releaseCurve: 'linear'
      }
    },
    MonoSynth: {
      detune: 0,
      volume: -10,
      portamento: 0,
      oscillator: {
        type: 'sine'
      },
      filter: {
        Q: 6,
        type: 'lowpass',
        rolloff: -24,
        wet: 0
      },
      envelope: {
        attack: 0.005,
        attackCurve: 'linear',
        decay: 0.1,
        sustain: 0.9,
        release: 1,
        releaseCurve: 'linear'
      },
      filterEnvelope: {
        attack: 0.06,
        decay: 0.2,
        sustain: 0.5,
        release: 2,
        baseFrequency: 200,
        octaves: 7,
        exponent: 2
      }
    },
    AMSynth: {
      oscillator: {
        type: 'sine'
      },
      volume: 0,
      harmonicity: 3,
      detune: 0,
      portamento: 0,
      modulation: {
        type: 'square'
      },
      envelope: {
        attack: 0.01,
        attackCurve: 'linear',
        decay: 0.01,
        sustain: 1,
        release: 0.5,
        releaseCurve: 'linear'
      },
      modulationEnvelope: {
        attack: 0.5,
        attackCurve: 'linear',
        decay: 0,
        sustain: 1,
        release: 0.5,
        releaseCurve: 'linear'
      }
    },
    FMSynth: {
      oscillator: {
        type: 'sine'
      },
      volume: 0,
      harmonicity: 3,
      modulationIndex: 10,
      detune: 0,
      portamento: 0,
      modulation: {
        type: 'square'
      },
      envelope: {
        attack: 0.01,
        attackCurve: 'linear',
        decay: 0.01,
        sustain: 1,
        release: 0.5,
        releaseCurve: 'linear'
      },
      modulationEnvelope: {
        attack: 0.5,
        attackCurve: 'linear',
        decay: 0,
        sustain: 1,
        release: 0.5,
        releaseCurve: 'linear'
      }
    },
    DuoSynth: {
      vibratoAmount: 0.5,
      vibratoRate: 5,
      harmonicity: 1.5,
      voice0: {
        volume: -10,
        portamento: 0,
        detune: 0,
        oscillator: {
          type: 'sine'
        },
        envelope: {
          attack: 0.01,
          attackCurve: 'linear',
          decay: 0,
          sustain: 1,
          release: 0.5,
          releaseCurve: 'linear'
        },
        filterEnvelope: {
          attack: 0.01,
          attackCurve: 'linear',
          decay: 0,
          sustain: 1,
          release: 0.5,
          releaseCurve: 'linear'
        }
      },
      voice1: {
        volume: -10,
        portamento: 0,
        detune: 0,
        oscillator: {
          type: 'sine'
        },
        envelope: {
          attack: 0.01,
          attackCurve: 'linear',
          decay: 0,
          sustain: 1,
          release: 0.5,
          releaseCurve: 'linear'
        },
        filterEnvelope: {
          attack: 0.01,
          attackCurve: 'linear',
          decay: 0,
          sustain: 1,
          release: 0.5,
          releaseCurve: 'linear'
        }
      }
    }
  },
  scales: [{
    name: 'Bright (Yo Scale)',
    config: [{ id: 0, keyCode: 'q', note: 'D', octave: 4 }, { id: 1, keyCode: 'w', note: 'E', octave: 4 }, { id: 2, keyCode: 'e', note: 'G', octave: 4 }, { id: 3, keyCode: 'r', note: 'A', octave: 4 }, { id: 4, keyCode: 't', note: 'B', octave: 4 }, { id: 5, keyCode: 'h', note: 'D', octave: 5 }, { id: 6, keyCode: 'j', note: 'E', octave: 5 }, { id: 7, keyCode: 'k', note: 'G', octave: 5 }, { id: 8, keyCode: 'l', note: 'A', octave: 5 }, { id: 9, keyCode: ';', note: 'B', octave: 5 }],
    triggers: {
      key: 'D',
      octave1: 4,
      octave2: 5
    },
    steps: [0, 2, 6, 8, 10]
  }, {
    name: 'Dark (In Scale)',
    config: [{ id: 0, keyCode: 'q', note: 'D', octave: 3 }, { id: 1, keyCode: 'w', note: 'D#', octave: 3 }, { id: 2, keyCode: 'e', note: 'G', octave: 3 }, { id: 3, keyCode: 'r', note: 'A', octave: 3 }, { id: 4, keyCode: 't', note: 'A#', octave: 3 }, { id: 5, keyCode: 'h', note: 'D', octave: 4 }, { id: 6, keyCode: 'j', note: 'D#', octave: 4 }, { id: 7, keyCode: 'k', note: 'G', octave: 4 }, { id: 8, keyCode: 'l', note: 'A', octave: 4 }, { id: 9, keyCode: ';', note: 'A#', octave: 4 }],
    triggers: {
      key: 'D',
      octave1: 3,
      octave2: 4
    },
    steps: [0, 1, 6, 8, 9]
  }],
  generalConfigOptions: {
    oscillators: {
      standard: ['sine', 'square', 'triangle', 'sawtooth']
    },
    envelopeCurves: ['linear', 'exponential', 'sine', 'cosine', 'bounce', 'ripple', 'step'],
    filter: {
      allTypes: ['lowpass', 'highpass', 'bandpass', 'lowshelf', 'highshelf', 'notch', 'allpass', 'peaking'],
      rollOffValues: [-12, -24, -48, -96]
    }
  }
};

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/* exports provided: db */
/* exports used: db */
/*!************************************!*\
  !*** ./client/plugins/firebase.js ***!
  \************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuefire__ = __webpack_require__(/*! vuefire */ 297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(/*! firebase */ 233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return db; });




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuefire___default.a);

var config = {
    apiKey: "AIzaSyAd1smP63cEltRztI1z4BU4G9Ua8lN0M50",
    authDomain: "jsradioorchestra.firebaseapp.com",
    databaseURL: "https://jsradioorchestra.firebaseio.com",
    projectId: "jsradioorchestra",
    storageBucket: "jsradioorchestra.appspot.com",
    messagingSenderId: "1096876541278"
};

var firebase = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.initializeApp(config);
var db = firebase.database();



/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/* unknown exports provided */
/* exports used: default */
/*!******************************************************!*\
  !*** ./client/components/player/backgroundvideo.vue ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-4e33ae52","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../~/vue-loader/lib/selector?type=styles&index=0!./backgroundvideo.vue */ 213)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./backgroundvideo.vue */ 189),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-4e33ae52"}!../../../~/vue-loader/lib/selector?type=template&index=0!./backgroundvideo.vue */ 277),
  /* scopeId */
  "data-v-4e33ae52",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************************************!*\
  !*** ./client/components/make_config/synths/triggers.vue ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-77954aef","scoped":true,"hasInlineConfig":false}!../../../../~/vue-loader/lib/selector?type=styles&index=0!./triggers.vue */ 222)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./triggers.vue */ 187),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-77954aef"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./triggers.vue */ 286),
  /* scopeId */
  "data-v-77954aef",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/* unknown exports provided */
/* exports used: default */
/*!**********************************************!*\
  !*** ./client/components/player/overlay.vue ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-2340cccc","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../~/vue-loader/lib/selector?type=styles&index=0!./overlay.vue */ 206)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./overlay.vue */ 191),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2340cccc"}!../../../~/vue-loader/lib/selector?type=template&index=0!./overlay.vue */ 270),
  /* scopeId */
  "data-v-2340cccc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/* unknown exports provided */
/* exports used: default */
/*!*********************************************!*\
  !*** ./client/components/player/player.vue ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-a2c2e7f2","scoped":true,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector?type=styles&index=0!./player.vue */ 225)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./player.vue */ 192),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-a2c2e7f2"}!../../../~/vue-loader/lib/selector?type=template&index=0!./player.vue */ 289),
  /* scopeId */
  "data-v-a2c2e7f2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/* exports provided: app, router, store */
/* exports used: app */
/*!***********************!*\
  !*** ./client/app.js ***!
  \***********************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__ = __webpack_require__(/*! vuex-router-sync */ 298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App__ = __webpack_require__(/*! ./components/App */ 240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(/*! ./router */ 169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(/*! ./store */ 170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics__ = __webpack_require__(/*! vue-analytics */ 239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_add_to_prototype_js__ = __webpack_require__(/*! ./plugins/add_to_prototype.js */ 167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_global_plugins_js__ = __webpack_require__(/*! ./plugins/global_plugins.js */ 168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_update_vuex_js__ = __webpack_require__(/*! ./utilities/update_vuex.js */ 171);
/* unused harmony reexport router */
/* unused harmony reexport store */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_analytics___default.a, {
  id: 'UA-109330238-1',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]
});





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_8__utilities_update_vuex_js__["a" /* updateVuexSynth */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_8__utilities_update_vuex_js__["b" /* updateVuexFilter */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin(__WEBPACK_IMPORTED_MODULE_8__utilities_update_vuex_js__["c" /* updateVuexEffect */]);

__webpack_require__(/*! ../static/globalstyles.scss */ 200);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */]);

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */](Object.assign({
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */]
}, __WEBPACK_IMPORTED_MODULE_2__components_App___default.a));

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin;



/***/ }),
/* 92 */
/* unknown exports provided */
/*!************************************!*\
  !*** ./client/promise-polyfill.js ***!
  \************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(/*! promise-polyfill */ 86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);


window.Promise = window.Promise || __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a;

/***/ }),
/* 93 */
/* unknown exports provided */
/* all exports used */
/*!***********************!*\
  !*** ./client/pwa.js ***!
  \***********************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__ = __webpack_require__(/*! offline-plugin/runtime */ 236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime__);


__WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.install({
  // When an update is ready, tell ServiceWorker to take control immediately:
  onUpdateReady: function onUpdateReady() {
    console.log('update ready');
    __WEBPACK_IMPORTED_MODULE_0_offline_plugin_runtime___default.a.applyUpdate();
  },


  // Reload to get the new version:
  onUpdated: function onUpdated() {
    console.log('updated');
    location.reload();
  }
});

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */
/* unknown exports provided */
/*!********************************************!*\
  !*** ./client/plugins/add_to_prototype.js ***!
  \********************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 17);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$_ = __webpack_require__(/*! lodash */ 84);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$Tone = __webpack_require__(/*! tone */ 238);

/***/ }),
/* 168 */
/* unknown exports provided */
/*!******************************************!*\
  !*** ./client/plugins/global_plugins.js ***!
  \******************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_youtube_embed__ = __webpack_require__(/*! vue-youtube-embed */ 296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_youtube_embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_youtube_embed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_u3c_u3c_vue__ = __webpack_require__(/*! ../components/u3c/u3c.vue */ 260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_u3c_u3c_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_u3c_u3c_vue__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_youtube_embed___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('u3c', __WEBPACK_IMPORTED_MODULE_2__components_u3c_u3c_vue___default.a);

/***/ }),
/* 169 */
/* exports provided: default */
/* exports used: default */
/*!********************************!*\
  !*** ./client/router/index.js ***!
  \********************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(/*! vue-router */ 294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home__ = __webpack_require__(/*! ../views/Home */ 262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Make__ = __webpack_require__(/*! ../views/Make */ 263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Make___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Make__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_All__ = __webpack_require__(/*! ../views/All */ 261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_All___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_All__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Single__ = __webpack_require__(/*! ../views/Single */ 264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Single___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_Single__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home___default.a
  }, {
    path: '/make',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Make___default.a
  }, {
    path: '/all',
    component: __WEBPACK_IMPORTED_MODULE_4__views_All___default.a
  }, {
    path: '/musicboxes',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Single___default.a
  }]
});

/***/ }),
/* 170 */
/* exports provided: state, mutations, actions, getters, default */
/* exports used: default */
/*!*******************************!*\
  !*** ./client/store/index.js ***!
  \*******************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 22);
/* unused harmony export state */
/* unused harmony export mutations */
/* unused harmony export actions */
/* unused harmony export getters */
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var _ = __webpack_require__(/*! lodash */ 84);

var state = {
  meta: {
    title: 'Our Little Planet',
    intro: 'It\'s a chance to sit quietly and make something small just for you. Take it',
    creator: '',
    length: 180,
    live: false
  },
  tone: {
    synth: 'AMSynth',
    synthMemberValues: {
      oscillator: {
        type: 'sine'
      },
      volume: 0,
      harmonicity: 3,
      detune: 0,
      portamento: 0,
      modulation: {
        type: 'square'
      },
      envelope: {
        attack: 0.01,
        attackCurve: 'linear',
        decay: 0.01,
        sustain: 1,
        release: 5,
        releaseCurve: 'linear'
      },
      modulationEnvelope: {
        attack: 0.5,
        attackCurve: 'linear',
        decay: 0,
        sustain: 1,
        release: 0.5,
        releaseCurve: 'linear'
      }
    },
    filter: false,
    filterMemberValues: {
      frequency: 1,
      type: 'lowpass',
      rolloff: -12,
      Q: 1
    },
    effectsConfig: [{ name: 'Chorus', active: false, oscillator: false }, { name: 'Tremolo', active: false, oscillator: true }, { name: 'Vibrato', active: false, oscillator: false }, { name: 'Freeverb', active: false, oscillator: false }],
    effectValues: { Chorus: { frequency: 1.5, delayTime: 3.5, depth: 0.7, feedback: 0.1, type: 'sine', spread: 180, wet: 1 }, Tremolo: { frequency: 10, type: 'sine', depth: 0.5, spread: 180, wet: 1 }, Vibrato: { maxDelay: 0.005, frequency: 5, depth: 0.1, type: 'sine', wet: 1 }, Freeverb: { roomSize: 0.7, dampening: 3000, wet: 1 } }
  },
  scale: {
    config: {
      octave1: 4,
      octave2: 5,
      key: 'D',
      scaleName: 'Dark (In Scale)',
      steps: [0, 2, 6, 8, 10]
    }
  },
  video: {
    videoId: '',
    params: {
      start: 0,
      end: 0,
      volume: 100
    }
  },
  overlay: {
    colorConfig: [{
      name: 'octave1',
      config: {
        'display': 'flex',
        'flex-direction': 'column',
        'justify-content': 'flex-start'
      },
      styles: [{ id: 0, grow: 1, offsetTop: 0, offsetLeft: 0, color: '#E583B4', startOpacity: 0, endOpacity: 1 }, { id: 1, grow: 1, offsetTop: 0, offsetLeft: 0, color: '#FAEE31', startOpacity: 0, endOpacity: 1 }, { id: 2, grow: 1, offsetTop: 0, offsetLeft: 0, color: '#67CAF4', startOpacity: 0, endOpacity: 1 }, { id: 3, grow: 1, offsetTop: 0, offsetLeft: 0, color: '#F2A172', startOpacity: 0, endOpacity: 1 }, { id: 4, grow: 1, offsetTop: 0, offsetLeft: 0, color: '#0F1A23', startOpacity: 0, endOpacity: 1 }]
    }, {
      name: 'octave2',
      config: {
        'display': 'flex',
        'flex-direction': 'column',
        'justify-content': 'flex-start'
      },
      styles: [{ id: 5, grow: 1, offsetTop: 0, offsetLeft: 0, color: '#CE5814', startOpacity: 0, endOpacity: 1 }, { id: 6, grow: 1, offsetTop: 0, offsetLeft: 0, color: '#72F2C2', startOpacity: 0, endOpacity: 1 }, { id: 7, grow: 1, offsetTop: 0, offsetLeft: 0, color: '#A472F2', startOpacity: 0, endOpacity: 1 }, { id: 8, grow: 1, offsetTop: 0, offsetLeft: 0, color: '#E4F272', startOpacity: 0, endOpacity: 1 }, { id: 9, grow: 1, offsetTop: 0, offsetLeft: 0, color: '#C7F272', startOpacity: 0, endOpacity: 1 }]
    }]
  },
  corruption: [{
    type: 'compression',
    active: true,
    members: {
      ratio: 20,
      // ratio: 1,
      threshold: -15,
      release: 0,
      attack: 0,
      knee: 10
    },
    start: 80
  }, {
    type: 'detune',
    active: true,
    detuneAmount: -5,
    interval: 10,
    start: 120
  }, {
    type: 'volumeDown',
    active: true,
    volumeDecrease: 1,
    minVolume: -20,
    interval: 8,
    start: 140
  }]
};

var mutations = {
  // ===== //
  // VIDEO //
  // ===== //
  SET_VIDEO_PARAMS: function SET_VIDEO_PARAMS(context, param) {
    _.merge(context.video, param);
  },

  // ======= //
  // OVERlAY //
  // ======= //
  SET_OVERLAY_BAND_PARAMS: function SET_OVERLAY_BAND_PARAMS(context, param) {
    var bandStyle = _.find(context.overlay.colorConfig[param.meta.arrayIndex].styles, { id: param.meta.id });
    _.merge(bandStyle, param.payload);
  },
  SET_OVERLAY_GROUP_PARAMS: function SET_OVERLAY_GROUP_PARAMS(context, param) {
    _.merge(context.overlay.colorConfig[param.meta.arrayIndex].config, param.payload);
  },
  RANDOM_OVERLAY_BAND: function RANDOM_OVERLAY_BAND(context, update) {
    _.merge(context.overlay.colorConfig[update.meta.arrayIndex].styles[update.meta.bandIndex], update.band);
  },
  RANDOM_OVERLAY_GROUP: function RANDOM_OVERLAY_GROUP(context, update) {
    _.merge(context.overlay.colorConfig[update.meta.arrayIndex].config, update.config);
  },

  // ===== //
  // SYNTH //
  // ===== //
  CHANGE_SYNTH_TYPE: function CHANGE_SYNTH_TYPE(context, payload) {
    context.tone.synth = payload.synthName;
    context.tone.synthMemberValues = payload.synthMemberValues;
  },
  UPDATE_SYNTH_MEMBER_VALUES: function UPDATE_SYNTH_MEMBER_VALUES(context, update) {
    _.merge(context.tone.synthMemberValues, update);
  },

  // ======= //
  // EFFECTS //
  // ======= //
  UPDATE_EFFECT_CONFIG: function UPDATE_EFFECT_CONFIG(context, payload) {
    _.merge(context.tone.effectValues[payload.effect], payload.update);
  },

  // ====== //
  // FILTER //
  // ====== //
  TOGGLE_ACTIVE_FILTER: function TOGGLE_ACTIVE_FILTER(context) {
    context.tone.filter = !context.tone.filter;
  },
  UPDATE_FILTER_MEMBER_VALUES: function UPDATE_FILTER_MEMBER_VALUES(context, update) {
    _.merge(context.tone.filterMemberValues, update);
  },

  // ======== //
  // TRIGGERS //
  // ======== //
  SET_OCTAVE1: function SET_OCTAVE1(context, octave) {
    context.scale.config.octave1 = octave;
  },
  SET_OCTAVE2: function SET_OCTAVE2(context, octave) {
    context.scale.config.octave2 = octave;
  },
  SET_KEY: function SET_KEY(context, key) {
    context.scale.config.key = key;
  },
  SET_SCALE: function SET_SCALE(context, scale) {
    context.scale.config.scaleName = scale.name;
    context.scale.config.steps = scale.steps;
  },

  // ======= //
  // OVERLAY //
  // ======= //
  SET_COLORS: function SET_COLORS(context, colorValues) {
    context.visuals.colorFilter = colorValues;
  },

  // ==== //
  // META //
  // ==== //
  UPDATE_META: function UPDATE_META(context, payload) {
    _.merge(context.meta, payload);
  },

  // ========== //
  // CORRUPTION //
  // ========== //
  SET_CORRUPTION_PARMS: function SET_CORRUPTION_PARMS(context, payload) {
    _.merge(context.corruption, payload);
  },

  // ======= //
  // GENERAL //
  // ======= //
  MOUNT_TRIGGERS: function MOUNT_TRIGGERS(context) {
    context.meta.triggersMounted = true;
  },

  // =============== //
  // INDIVIDUAL PAGE //
  // =============== //
  PLAY_CONFIG: function PLAY_CONFIG(context, config) {
    context.meta = config.meta;
    context.tone = config.tone;
    context.scale = config.scale;
    context.video = config.video;
    context.overlay = config.overlay;
    context.corruption = config.corruption;
  }
};

var actions = {
  // ===== //
  // SYNTH //
  // ===== //
  MUNGE_SYNTH_UPDATE: function MUNGE_SYNTH_UPDATE(context, payload) {
    var update = {};

    if (payload.subsubfield) {
      update = _defineProperty({}, payload.field, _defineProperty({}, payload.subfield, _defineProperty({}, payload.subsubfield, payload.value)));
    } else if (payload.subfield) {
      update = _defineProperty({}, payload.field, _defineProperty({}, payload.subfield, payload.value));
    } else {
      update = _defineProperty({}, payload.field, payload.value);
    }

    context.commit('SET_SYNTH_MEMBER_VALUES', { synth: context.getters.constructed_synth, update: update });
  },

  // ====== //
  // FILTER //
  // ====== //
  UPDATE_FILTER_MEMBER_VALUES: function UPDATE_FILTER_MEMBER_VALUES(context, values) {
    context.commit('SET_FILTER_MEMBER_VALUES', { filter: context.getters.constructed_filter, values: values });
  },

  // ========= //
  // Firebase //
  // ========= //
  GET_MUSICBOXES: function GET_MUSICBOXES(context) {
    console.log(this.$db);
  }
};

var getters = {
  active_scale: function active_scale(state) {
    var octave1 = state.scale.config.octave1;
    var octave2 = state.scale.config.octave2;
    var key = state.scale.config.key;
    var steps = state.scale.config.steps;

    var possibleNotes = ['A', 'A#', 'B', 'B#', 'C', 'C#', 'D', 'D#', 'E', 'E#', 'F', 'F#', 'G', 'G#'];
    var keyCodes = ['q', 'w', 'e', 'r', 't', 'h', 'j', 'k', 'l', ';'];
    var newOrigin = possibleNotes.indexOf(key);
    var newScale = possibleNotes.slice(newOrigin).concat(possibleNotes.slice(0, newOrigin));

    var scale = [];
    for (var i = 0; i < 10; i++) {
      var trigger = {};
      if (i < 5) {
        trigger = {
          id: i,
          keyCode: keyCodes[i],
          note: newScale[steps[i]],
          octave: octave1
        };
      } else {
        trigger = {
          id: i,
          keyCode: keyCodes[i],
          note: newScale[steps[i - 5]],
          octave: octave2
        };
      }
      trigger.noteToPlay = String(trigger.note) + String(trigger.octave);
      scale.push(trigger);
    }

    return scale;
  }
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/* harmony default export */ __webpack_exports__["a"] = store;

/***/ }),
/* 171 */
/* exports provided: updateVuexSynth, updateVuexFilter, updateVuexEffect */
/* exports used: updateVuexSynth, updateVuexFilter, updateVuexEffect */
/*!*****************************************!*\
  !*** ./client/utilities/update_vuex.js ***!
  \*****************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateVuexSynth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateVuexFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateVuexEffect; });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var updateVuexSynth = {
    methods: {
        updateVuexSynth: function updateVuexSynth(value, key, subKey, tertiaryKey) {
            var update = {};

            if (tertiaryKey) {
                update = _defineProperty({}, key, _defineProperty({}, subKey, _defineProperty({}, tertiaryKey, value)));
            } else if (!tertiaryKey && subKey) {
                update = _defineProperty({}, key, _defineProperty({}, subKey, value));
            } else {
                update = _defineProperty({}, key, value);
            }

            this.$store.commit('UPDATE_SYNTH_MEMBER_VALUES', update);
        }
    }
};

var updateVuexFilter = {
    methods: {
        updateVuexFilter: function updateVuexFilter(value, key) {
            var update = _defineProperty({}, key, value);

            this.$store.commit('UPDATE_FILTER_MEMBER_VALUES', update);
        }
    }
};

var updateVuexEffect = {
    methods: {
        updateVuexEffect: function updateVuexEffect(value, key, effect) {
            var update = {
                effect: effect,
                update: _defineProperty({}, key, value)
            };

            this.$store.commit('UPDATE_EFFECT_CONFIG', update);
        }
    }
};

/***/ }),
/* 172 */
/* exports provided: default */
/* all exports used */
/*!**********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/make_config/effects/chorus.vue ***!
  \**********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
	computed: {
		effectConfig: function effectConfig() {
			return this.$store.state.tone.effectValues.Chorus;
		}
	}
};

/***/ }),
/* 173 */
/* exports provided: default */
/* all exports used */
/*!************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/make_config/effects/freeverb.vue ***!
  \************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  computed: {
    effectConfig: function effectConfig() {
      return this.$store.state.tone.effectValues.Freeverb;
    }
  }
};

/***/ }),
/* 174 */
/* exports provided: default */
/* all exports used */
/*!***********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/make_config/effects/tremolo.vue ***!
  \***********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  computed: {
    effectConfig: function effectConfig() {
      return this.$store.state.tone.effectValues.Tremolo;
    }
  }
};

/***/ }),
/* 175 */
/* exports provided: default */
/* all exports used */
/*!***********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/make_config/effects/vibrato.vue ***!
  \***********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  computed: {
    effectConfig: function effectConfig() {
      return this.$store.state.tone.effectValues.Vibrato;
    }
  }
};

/***/ }),
/* 176 */
/* exports provided: default */
/* all exports used */
/*!*********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/make_config/filter_config.vue ***!
  \*********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_toneUtility_js__ = __webpack_require__(/*! ../../utilities/toneUtility.js */ 13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'tonefilter',
  data: function data() {
    return {
      options: __WEBPACK_IMPORTED_MODULE_0__utilities_toneUtility_js__["a" /* default */].generalConfigOptions
    };
  },

  computed: {
    configActive: function configActive() {
      return this.$store.state.tone.filter;
    },
    configValues: function configValues() {
      return this.$store.state.tone.filterMemberValues;
    }
  },
  methods: {
    toggleFilter: function toggleFilter() {
      this.$store.commit('TOGGLE_ACTIVE_FILTER');
    }
  }
};

/***/ }),
/* 177 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/make_config/meta_config.vue ***!
  \*******************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_firebase_js__ = __webpack_require__(/*! ../../plugins/firebase.js */ 16);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'demo',
  data: function data() {
    return {
      u3c: {
        about: 'Make your own digital music box. It looks confusing (and it is! Welcome to the under construction club! I no longer care about UX!) but honestly you\'ll figure it out. It\'ll be fine. If something is super impossible to use of confusing email me at alexcarusillo@gmail.com. If you see this box somewhere it means there\'s somethign that I think needs explanation',
        db: 'jsradioorchestra'
      }
    };
  },

  computed: {
    meta: function meta() {
      return this.$store.state.meta;
    }
  },
  firebase: {
    musicboxes: __WEBPACK_IMPORTED_MODULE_0__plugins_firebase_js__["a" /* db */].ref('musicboxes')
  },
  methods: {
    update: function update(key, value) {
      var update = _defineProperty({}, key, value);

      this.$store.commit('UPDATE_META', update);
    },
    save: function save() {
      // TODO: lol no fucking idea why https://stackoverflow.com/questions/31983225/error-firebase-set-failed-first-argument-contains-undefined-in-property-achv
      __WEBPACK_IMPORTED_MODULE_0__plugins_firebase_js__["a" /* db */].ref('musicboxes').push(JSON.parse(JSON.stringify(this.$store.state)));
      alert('saved!');
      this.$router.push('/all');
    }
  }
};

/***/ }),
/* 178 */
/* exports provided: default */
/* all exports used */
/*!***********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/make_config/mutation_config.vue ***!
  \***********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {

  name: 'mutation',

  data: function data() {
    return {
      mutations: [],
      u3c: {
        about: "I like the idea of digital decay and this is the first pass at what that might look like. My real goal is to introduce natural performance errors that will force sonic glitching naturally (think dust on a record) but while I work that out this fakes it so I can see how interesting it is. If you know browsers and have an idea how to do this (constantly repainting? Self-calling loops?) let me know!",
        instructions: "If you don't know what you're doing here just leave it off. Generally though you can change the time the corruption begins or turn it on/off. I've got a vague idea how can sync changes with the video which might be cool - it might also make it too much of a theme park ride so I dunno. Compression makes it really gritty and detune and volume down do exactly what it sounds like they do."
      }
    };
  },
  mounted: function mounted() {
    this.mutations = this.$_.cloneDeep(this.$store.state.corruption);
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('SET_CORRUPTION_PARMS', this.$_.cloneDeep(this.mutations));
  }
};

/***/ }),
/* 179 */
/* exports provided: default */
/* all exports used */
/*!**********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/make_config/overlay_config.vue ***!
  \**********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 22);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'colorfilter-config',
  props: ['active', 'transitions'],
  computed: {
    colorConfig: function colorConfig() {
      return this.$store.state.overlay.colorConfig;
    }
  },
  methods: {
    randomize: function randomize(type) {
      var vue = this;
      var octaveIndex = 0;
      var bandIndex = 0;

      this.colorConfig.forEach(function (octave) {
        var coinFlip = Math.floor(Math.random() * 2);

        if (coinFlip === 0) {
          octave.config['flex-direction'] = 'column';
        } else {
          octave.config['flex-direction'] = 'row';
        }

        octave.styles.forEach(function (band) {
          var coinFlip = Math.floor(Math.random() * 2);

          band.grow = Math.floor(Math.random() * 3) + 1;

          if (type === 'deep') {
            band.offsetTop = Math.floor(Math.random() * 40);
            band.offsetLeft = Math.floor(Math.random() * 40);
          }

          if (type === 'shallow') {
            band.offsetTop = 0;
            band.offsetLeft = 0;
          }

          if (coinFlip === 0) {
            band.offset = -band.offset;
          }

          band.color = '#' + Math.floor(Math.random() * 16777215).toString(16);

          var update = {
            meta: {
              bandIndex: bandIndex,
              arrayIndex: octaveIndex
            },
            band: band
          };
          vue.$store.commit('RANDOM_OVERLAY_BAND', update);
          if (bandIndex >= 4) {
            bandIndex = 0;
          } else {
            bandIndex++;
          }
        });

        var update = {
          meta: {
            arrayIndex: octaveIndex
          },
          config: octave.config
        };

        vue.$store.commit('RANDOM_OVERLAY_GROUP', update);
        octaveIndex++;
      });
    },
    updateBand: function updateBand(id, index, key, value) {
      var update = {
        meta: {
          arrayIndex: index,
          id: id
        },
        payload: _defineProperty({}, key, value)
      };

      this.$store.commit('SET_OVERLAY_BAND_PARAMS', update);
    },
    updateGroup: function updateGroup(index, key, value) {
      var update = {
        meta: {
          arrayIndex: index
        },
        payload: _defineProperty({}, key, value)
      };

      this.$store.commit('SET_OVERLAY_GROUP_PARAMS', update);
    }
  },
  mounted: function mounted() {
    this.$parent.showOverlay = true;
  }
};

/***/ }),
/* 180 */
/* exports provided: default */
/* all exports used */
/*!********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/make_config/scale_config.vue ***!
  \********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__synths_triggers_vue__ = __webpack_require__(/*! ./synths/triggers.vue */ 88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__synths_triggers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__synths_triggers_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  props: ['playing'],
  components: { synthTrigger: __WEBPACK_IMPORTED_MODULE_1__synths_triggers_vue___default.a },
  data: function data() {
    return {
      scales: [{
        id: 0,
        name: 'Bright (Yo Scale)',
        steps: [0, 2, 6, 8, 10]
      }, {
        id: 1,
        name: 'Dark (In Scale)',
        steps: [0, 1, 6, 8, 9]
      }],
      scaleConfig: {
        possibleNotes: ['A', 'A#', 'B', 'B#', 'C', 'C#', 'D', 'D#', 'E', 'E#', 'F', 'F#', 'G', 'G#'],
        possibleOctaves: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
      }
    };
  },

  computed: Object.assign({
    octave1: {
      get: function get() {
        return this.$store.state.scale.config.octave1;
      },
      set: function set(newOctave) {
        this.$store.commit('SET_OCTAVE1', newOctave);
      }
    },
    octave2: {
      get: function get() {
        return this.$store.state.scale.config.octave2;
      },
      set: function set(newOctave) {
        this.$store.commit('SET_OCTAVE2', newOctave);
      }
    },
    key: {
      get: function get() {
        return this.$store.state.scale.config.key;
      },
      set: function set(newKey) {
        this.$store.commit('SET_KEY', newKey);
      }
    },
    scaleName: {
      get: function get() {
        return this.$store.state.scale.config.scaleName;
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['active_scale'])),
  methods: {
    updateScale: function updateScale(event) {
      var newScale = this.scales[event.target.value];
      this.$store.commit('SET_SCALE', newScale);
    }
  }
};

/***/ }),
/* 181 */
/* exports provided: default */
/* all exports used */
/*!********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/make_config/synth_config.vue ***!
  \********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_toneUtility_js__ = __webpack_require__(/*! ../../utilities/toneUtility.js */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__synths_synth_vue__ = __webpack_require__(/*! ./synths/synth.vue */ 255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__synths_synth_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__synths_synth_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__synths_monosynth_vue__ = __webpack_require__(/*! ./synths/monosynth.vue */ 254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__synths_monosynth_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__synths_monosynth_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__synths_amsynth_vue__ = __webpack_require__(/*! ./synths/amsynth.vue */ 251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__synths_amsynth_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__synths_amsynth_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__synths_fmsynth_vue__ = __webpack_require__(/*! ./synths/fmsynth.vue */ 253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__synths_fmsynth_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__synths_fmsynth_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__synths_duosynth_vue__ = __webpack_require__(/*! ./synths/duosynth.vue */ 252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__synths_duosynth_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__synths_duosynth_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filter_config_vue__ = __webpack_require__(/*! ./filter_config.vue */ 245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filter_config_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__filter_config_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__effects_chorus_vue__ = __webpack_require__(/*! ./effects/chorus.vue */ 241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__effects_chorus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__effects_chorus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__effects_tremolo_vue__ = __webpack_require__(/*! ./effects/tremolo.vue */ 243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__effects_tremolo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__effects_tremolo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__effects_vibrato_vue__ = __webpack_require__(/*! ./effects/vibrato.vue */ 244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__effects_vibrato_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__effects_vibrato_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__effects_freeverb_vue__ = __webpack_require__(/*! ./effects/freeverb.vue */ 242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__effects_freeverb_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__effects_freeverb_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["default"] = {
  name: 'synth-config',
  components: {
    synth: __WEBPACK_IMPORTED_MODULE_1__synths_synth_vue___default.a, monosynth: __WEBPACK_IMPORTED_MODULE_2__synths_monosynth_vue___default.a, amsynth: __WEBPACK_IMPORTED_MODULE_3__synths_amsynth_vue___default.a, fmsynth: __WEBPACK_IMPORTED_MODULE_4__synths_fmsynth_vue___default.a, duosynth: __WEBPACK_IMPORTED_MODULE_5__synths_duosynth_vue___default.a, tonefilter: __WEBPACK_IMPORTED_MODULE_6__filter_config_vue___default.a, chorus: __WEBPACK_IMPORTED_MODULE_7__effects_chorus_vue___default.a, tremolo: __WEBPACK_IMPORTED_MODULE_8__effects_tremolo_vue___default.a, vibrato: __WEBPACK_IMPORTED_MODULE_9__effects_vibrato_vue___default.a, freeverb: __WEBPACK_IMPORTED_MODULE_10__effects_freeverb_vue___default.a
  },
  data: function data() {
    return {
      possibleSynths: ['Synth', 'MonoSynth', 'AMSynth', 'FMSynth', 'DuoSynth']
    };
  },

  computed: {
    activeScale: function activeScale() {
      return _.cloneDeep(this.$store.state.scale);
    },
    toneConfig: function toneConfig() {
      return this.$store.state.tone;
    },

    // TODO: This won't run in strict but like I give a fuckkkkkkkkkk (deal with this eventually, maybe :())
    effectsConfig: function effectsConfig() {
      return this.$store.state.tone.effectsConfig;
    }
  },
  methods: {
    changeSynth: function changeSynth(event) {
      var newSynth = {
        synthName: event.target.value,
        synthMemberValues: __WEBPACK_IMPORTED_MODULE_0__utilities_toneUtility_js__["a" /* default */].synthDefaults[event.target.value]
      };

      this.$store.commit('CHANGE_SYNTH_TYPE', newSynth);
    }
  }
};

/***/ }),
/* 182 */
/* exports provided: default */
/* all exports used */
/*!**********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/make_config/synths/amsynth.vue ***!
  \**********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_toneUtility_js__ = __webpack_require__(/*! ../../../utilities/toneUtility.js */ 13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'amsynth',
  data: function data() {
    return {
      options: __WEBPACK_IMPORTED_MODULE_0__utilities_toneUtility_js__["a" /* default */].generalConfigOptions
    };
  },

  computed: {
    config: function config() {
      return this.$store.state.tone.synthMemberValues;
    }
  }
};

/***/ }),
/* 183 */
/* exports provided: default */
/* all exports used */
/*!***********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/make_config/synths/duosynth.vue ***!
  \***********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_toneUtility_js__ = __webpack_require__(/*! ../../../utilities/toneUtility.js */ 13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'duosynth',
  data: function data() {
    return {
      options: __WEBPACK_IMPORTED_MODULE_0__utilities_toneUtility_js__["a" /* default */].generalConfigOptions
    };
  },

  computed: {
    config: function config() {
      return this.$store.state.tone.synthMemberValues;
    }
  }
};

/***/ }),
/* 184 */
/* exports provided: default */
/* all exports used */
/*!**********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/make_config/synths/fmsynth.vue ***!
  \**********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_toneUtility_js__ = __webpack_require__(/*! ../../../utilities/toneUtility.js */ 13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'fmsynth',
  data: function data() {
    return {
      options: __WEBPACK_IMPORTED_MODULE_0__utilities_toneUtility_js__["a" /* default */].generalConfigOptions
    };
  },

  computed: {
    config: function config() {
      return this.$store.state.tone.synthMemberValues;
    }
  }
};

/***/ }),
/* 185 */
/* exports provided: default */
/* all exports used */
/*!************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/make_config/synths/monosynth.vue ***!
  \************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_toneUtility_js__ = __webpack_require__(/*! ../../../utilities/toneUtility.js */ 13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'monosynth',
  data: function data() {
    return {
      options: __WEBPACK_IMPORTED_MODULE_0__utilities_toneUtility_js__["a" /* default */].generalConfigOptions
    };
  },

  computed: {
    config: function config() {
      return this.$store.state.tone.synthMemberValues;
    }
  }
};

/***/ }),
/* 186 */
/* exports provided: default */
/* all exports used */
/*!********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/make_config/synths/synth.vue ***!
  \********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_toneUtility_js__ = __webpack_require__(/*! ../../../utilities/toneUtility.js */ 13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      options: __WEBPACK_IMPORTED_MODULE_0__utilities_toneUtility_js__["a" /* default */].generalConfigOptions
    };
  },

  computed: {
    config: function config() {
      return this.$store.state.tone.synthMemberValues;
    }
  }
};

/***/ }),
/* 187 */
/* exports provided: default */
/* all exports used */
/*!***********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/make_config/synths/triggers.vue ***!
  \***********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'synthtrigger',
  props: ['config', 'playing']
};

/***/ }),
/* 188 */
/* exports provided: default */
/* all exports used */
/*!********************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/make_config/video_config.vue ***!
  \********************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player_backgroundvideo_vue__ = __webpack_require__(/*! ../player/backgroundvideo.vue */ 45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__player_backgroundvideo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__player_backgroundvideo_vue__);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {

  name: 'videoConfig',
  components: {
    backgroundVideo: __WEBPACK_IMPORTED_MODULE_0__player_backgroundvideo_vue___default.a
  },
  data: function data() {
    return {
      videoList: [{ title: 'micro burst near lowell indiana', id: 'L6CtOH8RVmM' }, { title: 'parking lot', id: 'm592XzAQfiw' }, { title: 'plane', id: 'esbfjBWuZ3o' }, { title: 'walk1', id: 'GFFWZ4Em1wM' }, { title: 'walk2', id: 'whjlvr-3Lxc' }, { title: 'walk3', id: 'o34e0406WL8' }, { title: 'walk4', id: 'g98gwuSo680' }]
    };
  },

  computed: {
    background: function background() {
      return this.$store.state.video;
    }
  },
  methods: {
    videoSelect: function videoSelect() {
      this.$store.commit('SET_VIDEO_PARAMS', { videoId: event.target.value });
    },
    update: function update(value, key, subkey) {
      var update = {};

      if (subkey !== undefined) {
        update = _defineProperty({}, key, _defineProperty({}, subkey, value));
      } else {
        update = _defineProperty({}, key, value);
      }

      this.$store.commit('SET_VIDEO_PARAMS', update);
    }
  }
};

/***/ }),
/* 189 */
/* exports provided: default */
/* all exports used */
/*!******************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/player/backgroundvideo.vue ***!
  \******************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  name: 'backgroundvideo',
  computed: {
    video: function video() {
      return this.$store.state.video;
    }
  },
  methods: {
    ready: function ready(player) {
      player.setVolume(this.video.params.volume);
      player.setPlaybackQuality('small');
    }
  }
};

/***/ }),
/* 190 */
/* exports provided: default */
/* all exports used */
/*!*************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/player/mountsynth.vue ***!
  \*************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 22);
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {

  name: 'mountsynth',
  data: function data() {
    return {
      synth: {},
      filter: {},
      effects: [],
      effectChainStart: {},
      effectChainEnd: {}
    };
  },

  computed: Object.assign({
    toneConfig: function toneConfig() {
      return this.$store.state.tone;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['active_scale'])),
  mounted: function mounted() {
    var _this = this;

    this.$Tone.context.close();
    this.$Tone.context = new AudioContext();

    this.synth = new this.$Tone.PolySynth(8, this.$Tone[this.toneConfig.synth]);
    this.synth.set(this.toneConfig.synthMemberValues);

    this.effectChainStart = new this.$Tone.Gain();
    this.synth.connect(this.effectChainStart);

    this.effectChainEnd = new this.$Tone.Gain();

    // Create and push effects to effect array
    var activeEffects = this.$_.filter(this.toneConfig.effectsConfig, { active: true });
    activeEffects.forEach(function (effect) {
      var toneEffect = new _this.$Tone[effect.name]();
      toneEffect.set(_this.toneConfig.effectValues[effect.name]);

      if (effect.oscillator) {
        toneEffect.start();
      }

      _this.effects.push(toneEffect);
    });

    if (this.effects.length > 0) {
      this.$_.forEach(this.effects, function (effect, index) {
        if (index === 0 && _this.effects.length === 1) {
          _this.effectChainStart.connect(effect);
          effect.connect(_this.effectChainEnd);
        } else if (index === 0) {
          _this.effectChainStart.connect(effect);
          effect.connect(_this.effects[index + 1]);
        } else if (index !== _this.effects.length - 1) {
          console.log(effect, '>', _this.effects[index + 1]);
          effect.connect(_this.effects[index + 1]);
        } else {
          effect.connect(_this.effectChainEnd);
        }
      });
    } else {
      this.effectChainStart.connect(this.effectChainEnd);
    }

    if (this.toneConfig.filter) {
      this.filter = new this.$Tone.Filter(this.toneConfig.filterMemberValues);
    } else {
      this.filter = new this.$Tone.Gain();
    }

    this.effectChainEnd.connect(this.filter);
    this.filter.connect(this.$Tone.Master);

    // Corruption
    this.$_.forEach(this.$store.state.corruption, function (effect) {
      console.log(effect);

      if (effect.type === 'detune' && effect.active) {

        _this.$Tone.Transport.scheduleOnce(function (time) {
          var detuneAmount = 0;
          _this.$Tone.Transport.scheduleRepeat(function (time) {
            detuneAmount += effect.detuneAmount;

            _this.synth.set({ 'detune': detuneAmount });
          }, String(effect.interval) + 's');
        }, String(effect.start) + 's');
      }

      if (effect.type === 'volumeDown' && effect.active) {

        _this.$Tone.Transport.scheduleOnce(function (time) {
          var volume = 0;
          _this.$Tone.Transport.scheduleRepeat(function (time) {
            volume -= effect.volumeDecrease;
            if (volume > effect.minVolume) {
              _this.synth.set({ 'volume': volume });
            } else {
              // Cancel this probably
            }
          }, String(effect.interval) + 's');
        }, String(effect.start) + 's');
      }

      if (effect.type === 'compression' && effect.active) {
        _this.$Tone.Transport.scheduleOnce(function (time) {
          var compressor = new _this.$Tone.Compressor(effect.members).toMaster();
          _this.filter.disconnect(_this.$Tone.Master);
          _this.filter.connect(compressor);
        }, effect.start);
      }
    });

    this.$_.forEach(this.active_scale, function (trigger) {
      window.addEventListener('keydown', function (e) {
        if (e.key === trigger.keyCode & !e.repeat) {
          _this.synth.triggerAttack(trigger.noteToPlay);
          _this.$emit('attackStart', trigger.id);
        }
      });

      window.addEventListener('keyup', function (e) {
        if (e.key === trigger.keyCode & !e.repeat) {
          _this.synth.triggerRelease(trigger.noteToPlay);
          _this.$emit('releaseStart', trigger.id);
        }
      });
    });
  }
};

/***/ }),
/* 191 */
/* exports provided: default */
/* all exports used */
/*!**********************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/player/overlay.vue ***!
  \**********************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {

  name: 'colorfilter',
  props: ['active'],
  data: function data() {
    return {};
  },

  computed: {
    config: function config() {
      return this.$store.state.overlay.colorConfig;
    },
    transitions: function transitions() {
      if (this.$store.state.tone.synth === 'DuoSynth') {
        return this.$store.state.tone.synthMemberValues.voice0.envelope;
      } else {
        return this.$store.state.tone.synthMemberValues.envelope;
      }
    },
    layout: function layout() {
      var vue = this;

      function baseStyles(octave, bandValues) {
        this['flex-grow'] = bandValues.grow;
        this['background-color'] = bandValues.color;

        this.position = 'relative';
        this.top = String(bandValues.offsetTop) + '%';
        this.left = String(bandValues.offsetLeft) + '%';
      }

      function transitionIn(bandValues) {
        this.opacity = bandValues.endOpacity;
        this.transition = 'opacity ' + String(vue.transitions.attack) + 's ease';
      }

      function transitionOut(bandValues) {
        this.opacity = bandValues.startOpacity;
        this.transition = 'opacity ' + String(vue.transitions.release) + 's ease';
      }

      var LAYOUT = [];

      this.config.forEach(function (octave) {
        var munge = {
          config: octave.config,
          bands: []
        };

        octave.styles.forEach(function (bandValues) {
          var band = {
            index: bandValues.id,
            base: new baseStyles(octave, bandValues),
            transitionIn: new transitionIn(bandValues),
            transitionOut: new transitionOut(bandValues)
          };
          munge.bands.push(band);
        });

        LAYOUT.push(munge);
      });

      return LAYOUT;
    }
  },
  methods: {
    saveLayout: function saveLayout() {
      this.$store.commit('SET_COLORS', this.layout);
    }
  }
};

/***/ }),
/* 192 */
/* exports provided: default */
/* all exports used */
/*!*********************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/player/player.vue ***!
  \*********************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overlay_vue__ = __webpack_require__(/*! ./overlay.vue */ 89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overlay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__overlay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backgroundvideo_vue__ = __webpack_require__(/*! ./backgroundvideo.vue */ 45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__backgroundvideo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__backgroundvideo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mountsynth_vue__ = __webpack_require__(/*! ./mountsynth.vue */ 257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mountsynth_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__mountsynth_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__titlecard_vue__ = __webpack_require__(/*! ./titlecard.vue */ 258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__titlecard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__titlecard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_u3c_newsletterSignup_vue__ = __webpack_require__(/*! ../../components/u3c/newsletterSignup.vue */ 259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_u3c_newsletterSignup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_u3c_newsletterSignup_vue__);
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = {
  name: 'player',
  components: {
    colorFilterOverlay: __WEBPACK_IMPORTED_MODULE_0__overlay_vue___default.a, backgroundVideo: __WEBPACK_IMPORTED_MODULE_1__backgroundvideo_vue___default.a, mountSynth: __WEBPACK_IMPORTED_MODULE_2__mountsynth_vue___default.a, titleCard: __WEBPACK_IMPORTED_MODULE_3__titlecard_vue___default.a, newsletterSignup: __WEBPACK_IMPORTED_MODULE_4__components_u3c_newsletterSignup_vue___default.a
  },
  data: function data() {
    return {
      showTitle: true,
      playbackEnded: false,
      playing: {
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false
      }
    };
  },

  methods: {
    attackStart: function attackStart(trigger) {
      this.playing[trigger] = true;
    },
    releaseStart: function releaseStart(trigger) {
      this.playing[trigger] = false;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$Tone.Transport.start();
    // Title card animations
    this.$Tone.Transport.scheduleOnce(function (time) {
      _this.showTitle = false;
    }, '15s');

    this.$Tone.Transport.scheduleOnce(function (time) {
      _this.showTitle = true;
    }, String(this.$store.state.meta.length) + 's');

    this.$Tone.Transport.scheduleOnce(function (time) {
      console.log('player ended');
      _this.$emit('ended');
      _this.showTitle = false;
      _this.playbackEnded = true;
    }, String(Number(this.$store.state.meta.length) + 10) + 's');
  }
};

/***/ }),
/* 193 */
/* exports provided: default */
/* all exports used */
/*!************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/player/titlecard.vue ***!
  \************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {

  name: 'titlecard',
  computed: {
    card: function card() {
      return this.$store.state.meta;
    }
  }
};

/***/ }),
/* 194 */
/* exports provided: default */
/* all exports used */
/*!****************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/u3c/newsletterSignup.vue ***!
  \****************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_firebase_js__ = __webpack_require__(/*! ../../plugins/firebase.js */ 16);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'newsletterSignup',
  data: function data() {
    return {
      active: true,
      email: ''
    };
  },

  firebase: {
    newsletter: __WEBPACK_IMPORTED_MODULE_0__plugins_firebase_js__["a" /* db */].ref('newsletterSignups')
  },
  methods: {
    newsletterSignup: function newsletterSignup() {
      this.active = false;
      this.$firebaseRefs.newsletter.push({ email: this.email });
    }
  }
};

/***/ }),
/* 195 */
/* exports provided: default */
/* all exports used */
/*!***************************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/components/u3c/u3c.vue ***!
  \***************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_firebase_js__ = __webpack_require__(/*! ../../plugins/firebase.js */ 16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'ucc',
  props: ['config'],
  data: function data() {
    return {
      state: 'text',
      newComment: '',
      explainer: false,
      min: true
    };
  },

  firebase: {
    guestbook: __WEBPACK_IMPORTED_MODULE_0__plugins_firebase_js__["a" /* db */].ref('guestbook')
  },
  computed: {
    comments: function comments() {
      return _.reverse(_.sortBy(this.guestbook, ['date']));
    }
  },
  methods: {
    post: function post() {
      this.$firebaseRefs.guestbook.push({ text: this.newComment, date: Date.now() });
      this.newComment = '';
    }
  }
};

/***/ }),
/* 196 */
/* exports provided: default */
/* all exports used */
/*!******************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/views/All.vue ***!
  \******************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_firebase_js__ = __webpack_require__(/*! ../plugins/firebase.js */ 16);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = {
  name: 'all',
  head: function head() {
    return {
      title: 'All Music Boxes'
    };
  },

  firebase: {
    musicBoxes: __WEBPACK_IMPORTED_MODULE_0__plugins_firebase_js__["a" /* db */].ref('musicboxes')
  }
};

/***/ }),
/* 197 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/views/Home.vue ***!
  \*******************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_firebase_js__ = __webpack_require__(/*! ../plugins/firebase.js */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_player_player_vue__ = __webpack_require__(/*! ../components/player/player.vue */ 90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_player_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_player_player_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'single',
  components: {
    player: __WEBPACK_IMPORTED_MODULE_1__components_player_player_vue___default.a
  },
  data: function data() {
    return {
      userStart: false,
      u3c: {
        about: 'This digital music box was created in our little planet. Read more about it at under-construction.club and make your own at /make.',
        instructions: 'It\'s an instrument. play it with the keys above however you think is best. you can\'t share it, no one else will ever hear it, etc etc. just a thing for you right now.',
        db: 'jsradioorchestra'
      }
    };
  },

  methods: {
    start: function start() {
      var player = document.getElementById('player');

      if (player.requestFullscreen) {
        player.requestFullscreen();
      } else if (player.mozRequestFullScreen) {
        player.mozRequestFullScreen();
      } else if (player.webkitRequestFullscreen) {
        player.webkitRequestFullscreen();
      } else if (player.msRequestFullscreen) {
        player.msRequestFullscreen();
      }
      this.userStart = true;
    },
    ended: function ended() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$bindAsObject('boxConfig', __WEBPACK_IMPORTED_MODULE_0__plugins_firebase_js__["a" /* db */].ref('musicboxes').child('-KxFZ8QPcpWsEsdiRmha'), function (cancel) {
      alert('something broken i dunno');
      console.log(cancel);
    }, function (ready) {
      _this.$store.commit('PLAY_CONFIG', _this.boxConfig);
    });
  }
};

/***/ }),
/* 198 */
/* exports provided: default */
/* all exports used */
/*!*******************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/views/Make.vue ***!
  \*******************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_make_config_synths_triggers_vue__ = __webpack_require__(/*! ../components/make_config/synths/triggers.vue */ 88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_make_config_synths_triggers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_make_config_synths_triggers_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_make_config_meta_config_vue__ = __webpack_require__(/*! ../components/make_config/meta_config.vue */ 246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_make_config_meta_config_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_make_config_meta_config_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_make_config_synth_config_vue__ = __webpack_require__(/*! ../components/make_config/synth_config.vue */ 250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_make_config_synth_config_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_make_config_synth_config_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_make_config_scale_config_vue__ = __webpack_require__(/*! ../components/make_config/scale_config.vue */ 249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_make_config_scale_config_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_make_config_scale_config_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_make_config_video_config_vue__ = __webpack_require__(/*! ../components/make_config/video_config.vue */ 256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_make_config_video_config_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_make_config_video_config_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_make_config_overlay_config_vue__ = __webpack_require__(/*! ../components/make_config/overlay_config.vue */ 248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_make_config_overlay_config_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_make_config_overlay_config_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_make_config_mutation_config_vue__ = __webpack_require__(/*! ../components/make_config/mutation_config.vue */ 247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_make_config_mutation_config_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_make_config_mutation_config_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_player_backgroundvideo_vue__ = __webpack_require__(/*! ../components/player/backgroundvideo.vue */ 45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_player_backgroundvideo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_player_backgroundvideo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_player_overlay_vue__ = __webpack_require__(/*! ../components/player/overlay.vue */ 89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_player_overlay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_player_overlay_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// Config Components







// Player Components



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    synthTrigger: __WEBPACK_IMPORTED_MODULE_1__components_make_config_synths_triggers_vue___default.a, metaConfig: __WEBPACK_IMPORTED_MODULE_2__components_make_config_meta_config_vue___default.a, videoConfig: __WEBPACK_IMPORTED_MODULE_5__components_make_config_video_config_vue___default.a, synthConfig: __WEBPACK_IMPORTED_MODULE_3__components_make_config_synth_config_vue___default.a, scaleConfig: __WEBPACK_IMPORTED_MODULE_4__components_make_config_scale_config_vue___default.a, overlayConfig: __WEBPACK_IMPORTED_MODULE_6__components_make_config_overlay_config_vue___default.a, mutationConfig: __WEBPACK_IMPORTED_MODULE_7__components_make_config_mutation_config_vue___default.a, backgroundVideo: __WEBPACK_IMPORTED_MODULE_8__components_player_backgroundvideo_vue___default.a, colorFilterOverlay: __WEBPACK_IMPORTED_MODULE_9__components_player_overlay_vue___default.a
  },
  data: function data() {
    return {
      activeView: 'meta',
      showVideo: false,
      showOverlay: false,
      showConfig: true,
      playing: {
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false
      },
      tone: {
        synth: {},
        effects: [],
        filter: {},
        effectChainStart: {},
        effectChainEnd: {}
      }
    };
  },

  computed: Object.assign({
    toneConfigSynthName: function toneConfigSynthName() {
      return this.$store.state.tone.synth;
    },
    toneConfigSynthValues: function toneConfigSynthValues() {
      return this.$store.state.tone.synthMemberValues;
    },
    toneConfigFilter: function toneConfigFilter() {
      return this.$store.state.tone.filter;
    },
    toneConfigFilterValues: function toneConfigFilterValues() {
      return this.$store.state.tone.filterMemberValues;
    },
    toneConfigEffectsList: function toneConfigEffectsList() {
      return this.$store.state.tone.effectsConfig;
    },
    toneConfigEffectValues: function toneConfigEffectValues() {
      return this.$store.state.tone.effectValues;
    },
    chorusEffect: function chorusEffect() {
      return this.$store.state.tone.effectValues.Chorus;
    },
    tremoloEffect: function tremoloEffect() {
      return this.$store.state.tone.effectValues.Tremolo;
    },
    vibratoEffect: function vibratoEffect() {
      return this.$store.state.tone.effectValues.Vibrato;
    },
    freeverbEffect: function freeverbEffect() {
      return this.$store.state.tone.effectValues.Freeverb;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['active_scale'])),
  watch: {
    toneConfigSynthName: {
      handler: function handler() {
        this.tone.synth.disconnect(this.tone.effectChainStart);
        this.tone.synth = new this.$Tone.PolySynth(8, this.$Tone[this.toneConfigSynthName]);
        this.tone.synth.set(this.toneConfigSynthValues);
        this.tone.synth.connect(this.tone.effectChainStart);
      }
    },
    toneConfigSynthValues: {
      handler: function handler() {
        this.tone.synth.set(this.toneConfigSynthValues);
      },

      deep: true
    },
    toneConfigFilter: {
      handler: function handler() {
        this.tone.effectChainEnd.disconnect(this.tone.filter);
        this.tone.filter = {};

        if (this.toneConfigFilter) {
          this.tone.filter = new this.$Tone.Filter(this.toneConfigFilterValues);
        } else {
          this.tone.filter = new this.$Tone.Gain();
        }

        this.tone.effectChainEnd.connect(this.tone.filter);
        this.tone.filter.connect(this.$Tone.Master);
      }
    },
    toneConfigFilterValues: {
      handler: function handler() {
        this.tone.filter.set(this.toneConfigFilterValues);
      },

      deep: true
    },
    toneConfigEffectsList: {
      handler: function handler() {
        var _this = this;

        // Disconnect Effects

        // Disconnect effect chain
        this.tone.effectChainStart.disconnect(this.tone.effects[0]);

        this.$_.forEach(this.tone.effects, function (effect, index) {
          if (index === 0 && _this.tone.effects.length === 1) {
            effect.disconnect(_this.tone.effectChainEnd);
          } else if (index !== _this.tone.effects.length - 1) {
            effect.disconnect(_this.tone.effects[index + 1]);
          } else {
            effect.disconnect(_this.tone.effectChainEnd);
          }
        });

        // Reset effect object
        this.tone.effects = [];

        // Create and push effects to effect array
        var activeEffects = this.$_.filter(this.toneConfigEffectsList, { active: true });
        activeEffects.forEach(function (effect) {
          var toneEffect = new _this.$Tone[effect.name]();
          toneEffect.set(_this.toneConfigEffectValues[effect.name]);
          toneEffect.name = effect.name;

          if (effect.oscillator) {
            toneEffect.start();
          }

          _this.tone.effects.push(toneEffect);
        });

        // Connect it all
        this.$_.forEach(this.tone.effects, function (effect, index) {
          if (index === 0 && _this.tone.effects.length === 1) {
            _this.tone.effectChainStart.connect(effect);
            effect.connect(_this.tone.effectChainEnd);
          } else if (index === 0) {
            _this.tone.effectChainStart.connect(effect);
            effect.connect(_this.tone.effects[index + 1]);
          } else if (index !== _this.tone.effects.length - 1) {
            effect.connect(_this.tone.effects[index + 1]);
          } else {
            effect.connect(_this.tone.effectChainEnd);
          }
        });

        if (this.tone.effects.length === 0) {
          this.tone.effectChainStart.connect(this.tone.effectChainEnd);
        }
      },

      deep: true
    },
    chorusEffect: {
      handler: function handler(newValues) {
        var effect = this.$_.find(this.tone.effects, { name: 'Chorus' });
        effect.set(newValues);
      },

      deep: true
    },
    tremoloEffect: {
      handler: function handler(newValues) {
        var effect = this.$_.find(this.tone.effects, { name: 'Tremolo' });
        effect.set(newValues);
      },

      deep: true
    },
    vibratoEffect: {
      handler: function handler(newValues) {
        var effect = this.$_.find(this.tone.effects, { name: 'Vibrato' });
        effect.set(newValues);
      },

      deep: true
    },
    freeverbEffect: {
      handler: function handler(newValues) {
        var effect = this.$_.find(this.tone.effects, { name: 'Freeverb' });
        effect.set(newValues);
      },

      deep: true
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$Tone.context.close();
    this.$Tone.context = new AudioContext();

    this.tone.synth = new this.$Tone.PolySynth(8, this.$Tone[this.toneConfigSynthName]);
    this.tone.synth.set(this.toneConfigSynthValues);

    this.tone.effectChainStart = new this.$Tone.Gain();
    this.tone.synth.connect(this.tone.effectChainStart);

    this.tone.effectChainEnd = new this.$Tone.Gain();

    // Create and push effects to effect array
    var activeEffects = this.$_.filter(this.toneConfigEffectsList, { active: true });
    activeEffects.forEach(function (effect) {
      var toneEffect = new _this2.$Tone[effect.name]();
      toneEffect.set(_this2.toneConfigEffectValues[effect.name]);
      toneEffect.name = effect.name;

      if (toneEffect.oscillator) {
        toneEffect.start();
      }

      _this2.tone.effects.push(toneEffect);
    });

    if (this.tone.effects.length > 0) {
      this.$_.forEach(this.tone.effects, function (effect, index) {
        if (index === 0 && _this2.tone.effects.length === 1) {
          _this2.tone.effectChainStart.connect(effect);
          effect.connect(_this2.tone.effectChainEnd);
        } else if (index === 0) {
          _this2.tone.effectChainStart.connect(effect);
          effect.connect(_this2.tone.effects[index + 1]);
        } else if (index !== _this2.tone.effects.length - 1) {
          console.log(effect, '>', _this2.tone.effects[index + 1]);
          effect.connect(_this2.tone.effects[index + 1]);
        } else {
          effect.connect(_this2.tone.effectChainEnd);
        }
      });
    } else {
      this.tone.effectChainStart.connect(this.tone.effectChainEnd);
    }

    if (this.toneConfigFilter) {
      this.tone.filter = new this.$Tone.Filter(this.toneConfigFilterValues);
    } else {
      this.tone.filter = new this.$Tone.Gain();
    }

    this.tone.effectChainEnd.connect(this.tone.filter);

    this.tone.filter.connect(this.$Tone.Master);

    // Set Triggers
    this.$_.forEach(this.active_scale, function (pitch, index) {
      window.addEventListener('keydown', function (e) {
        if (e.key === pitch.keyCode & !e.repeat) {
          _this2.tone.synth.triggerAttack(_this2.active_scale[index].noteToPlay);
          _this2.playing[index] = true;
        }
      });

      window.addEventListener('keyup', function (e) {
        if (e.key === pitch.keyCode & !e.repeat) {
          _this2.tone.synth.triggerRelease(_this2.active_scale[index].noteToPlay);
          _this2.playing[index] = false;
        }
      });
    });
  }
};

/***/ }),
/* 199 */
/* exports provided: default */
/* all exports used */
/*!*********************************************************************************************************!*\
  !*** ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./client/views/Single.vue ***!
  \*********************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_firebase_js__ = __webpack_require__(/*! ../plugins/firebase.js */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_player_player_vue__ = __webpack_require__(/*! ../components/player/player.vue */ 90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_player_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_player_player_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'single',
  components: {
    player: __WEBPACK_IMPORTED_MODULE_1__components_player_player_vue___default.a
  },
  data: function data() {
    return {
      userStart: false,
      u3c: {
        about: 'This digital music box was created in our little planet. Read more about it at under-construction.club and make your own at /make.',
        instructions: 'It\'s an instrument. play it with the keys above however you think is best. you can\'t share it, no one else will ever hear it, etc etc. just a thing for you right now.',
        db: 'jsradioorchestra'
      }
    };
  },

  methods: {
    start: function start() {
      var player = document.getElementById('player');

      if (player.requestFullscreen) {
        player.requestFullscreen();
      } else if (player.mozRequestFullScreen) {
        player.mozRequestFullScreen();
      } else if (player.webkitRequestFullscreen) {
        player.webkitRequestFullscreen();
      } else if (player.msRequestFullscreen) {
        player.msRequestFullscreen();
      }
      this.userStart = true;
    },
    ended: function ended() {
      console.log('parent ended');
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  },
  created: function created() {
    var _this = this;

    this.$bindAsObject('boxConfig', __WEBPACK_IMPORTED_MODULE_0__plugins_firebase_js__["a" /* db */].ref('musicboxes').child(this.$route.query.id), function (cancel) {
      console.log(cancel);
    }, function (ready) {
      _this.$store.commit('PLAY_CONFIG', _this.boxConfig);
    });
  }
};

/***/ }),
/* 200 */
/* unknown exports provided */
/* all exports used */
/*!**********************************!*\
  !*** ./static/globalstyles.scss ***!
  \**********************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-16d08bda","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/make_config/video_config.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-1812243f","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/views/All.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-187bd351","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/make_config/synths/fmsynth.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/* unknown exports provided */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-1c810c9a","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/views/Single.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/* unknown exports provided */
/* all exports used */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-1d0c6c33","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/u3c/newsletterSignup.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-2340cccc","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/player/overlay.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-2b043938","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/make_config/synths/synth.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/* unknown exports provided */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-2b07e718","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/make_config/meta_config.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-2bfc60aa","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/make_config/scale_config.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/* unknown exports provided */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-2c86c02e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/player/mountsynth.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-3004558c","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/make_config/synths/amsynth.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-3d9aea9a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/u3c/u3c.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/* unknown exports provided */
/* all exports used */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-4e33ae52","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/player/backgroundvideo.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-4f1655e5","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/make_config/overlay_config.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-5850d632","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/player/titlecard.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-5abb859b","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/make_config/effects/tremolo.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-5b91e14c","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/make_config/effects/freeverb.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-61980bc8","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/make_config/effects/vibrato.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/* unknown exports provided */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-64a88031","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/views/Home.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-672959f4","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/make_config/mutation_config.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-6ef47b39","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/App.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/* unknown exports provided */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-77954aef","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/make_config/synths/triggers.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/* unknown exports provided */
/* all exports used */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-78917ac5","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/make_config/filter_config.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-7c054627","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/make_config/effects/chorus.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-a2c2e7f2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/player/player.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-a9b38896","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/make_config/synths/monosynth.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-b3655b0e","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/make_config/synth_config.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-d65a589c","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/components/make_config/synths/duosynth.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/* unknown exports provided */
/* all exports used */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap&-autoprefixer!./~/vue-loader/lib/style-compiler?{"id":"data-v-f7e51c80","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?sourceMap!./~/vue-loader/lib/selector.js?type=styles&index=0!./client/views/Make.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************!*\
  !*** ./client/components/App.vue ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-6ef47b39","scoped":false,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./App.vue */ 221)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  null,
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-6ef47b39"}!../../~/vue-loader/lib/selector?type=template&index=0!./App.vue */ 285),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/* unknown exports provided */
/* exports used: default */
/*!**********************************************************!*\
  !*** ./client/components/make_config/effects/chorus.vue ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-7c054627","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../../~/vue-loader/lib/selector?type=styles&index=0!./chorus.vue */ 224)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./chorus.vue */ 172),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-7c054627"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./chorus.vue */ 288),
  /* scopeId */
  "data-v-7c054627",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/* unknown exports provided */
/* exports used: default */
/*!************************************************************!*\
  !*** ./client/components/make_config/effects/freeverb.vue ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-5b91e14c","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../../~/vue-loader/lib/selector?type=styles&index=0!./freeverb.vue */ 217)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./freeverb.vue */ 173),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-5b91e14c"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./freeverb.vue */ 281),
  /* scopeId */
  "data-v-5b91e14c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************************************!*\
  !*** ./client/components/make_config/effects/tremolo.vue ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-5abb859b","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../../~/vue-loader/lib/selector?type=styles&index=0!./tremolo.vue */ 216)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./tremolo.vue */ 174),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-5abb859b"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./tremolo.vue */ 280),
  /* scopeId */
  "data-v-5abb859b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************************************!*\
  !*** ./client/components/make_config/effects/vibrato.vue ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-61980bc8","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../../~/vue-loader/lib/selector?type=styles&index=0!./vibrato.vue */ 218)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./vibrato.vue */ 175),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-61980bc8"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./vibrato.vue */ 282),
  /* scopeId */
  "data-v-61980bc8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/* unknown exports provided */
/* exports used: default */
/*!*********************************************************!*\
  !*** ./client/components/make_config/filter_config.vue ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-78917ac5","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../~/vue-loader/lib/selector?type=styles&index=0!./filter_config.vue */ 223)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./filter_config.vue */ 176),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-78917ac5"}!../../../~/vue-loader/lib/selector?type=template&index=0!./filter_config.vue */ 287),
  /* scopeId */
  "data-v-78917ac5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************************************!*\
  !*** ./client/components/make_config/meta_config.vue ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-2b07e718","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../~/vue-loader/lib/selector?type=styles&index=0!./meta_config.vue */ 208)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./meta_config.vue */ 177),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2b07e718"}!../../../~/vue-loader/lib/selector?type=template&index=0!./meta_config.vue */ 272),
  /* scopeId */
  "data-v-2b07e718",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************************************!*\
  !*** ./client/components/make_config/mutation_config.vue ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-672959f4","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../~/vue-loader/lib/selector?type=styles&index=0!./mutation_config.vue */ 220)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./mutation_config.vue */ 178),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-672959f4"}!../../../~/vue-loader/lib/selector?type=template&index=0!./mutation_config.vue */ 284),
  /* scopeId */
  "data-v-672959f4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/* unknown exports provided */
/* exports used: default */
/*!**********************************************************!*\
  !*** ./client/components/make_config/overlay_config.vue ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-4f1655e5","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../~/vue-loader/lib/selector?type=styles&index=0!./overlay_config.vue */ 214)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./overlay_config.vue */ 179),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-4f1655e5"}!../../../~/vue-loader/lib/selector?type=template&index=0!./overlay_config.vue */ 278),
  /* scopeId */
  "data-v-4f1655e5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/* unknown exports provided */
/* exports used: default */
/*!********************************************************!*\
  !*** ./client/components/make_config/scale_config.vue ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-2bfc60aa","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../~/vue-loader/lib/selector?type=styles&index=0!./scale_config.vue */ 209)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./scale_config.vue */ 180),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2bfc60aa"}!../../../~/vue-loader/lib/selector?type=template&index=0!./scale_config.vue */ 273),
  /* scopeId */
  "data-v-2bfc60aa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/* unknown exports provided */
/* exports used: default */
/*!********************************************************!*\
  !*** ./client/components/make_config/synth_config.vue ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-b3655b0e","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../~/vue-loader/lib/selector?type=styles&index=0!./synth_config.vue */ 227)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./synth_config.vue */ 181),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-b3655b0e"}!../../../~/vue-loader/lib/selector?type=template&index=0!./synth_config.vue */ 291),
  /* scopeId */
  "data-v-b3655b0e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/* unknown exports provided */
/* exports used: default */
/*!**********************************************************!*\
  !*** ./client/components/make_config/synths/amsynth.vue ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-3004558c","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../../~/vue-loader/lib/selector?type=styles&index=0!./amsynth.vue */ 211)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./amsynth.vue */ 182),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-3004558c"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./amsynth.vue */ 275),
  /* scopeId */
  "data-v-3004558c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */
/* unknown exports provided */
/* exports used: default */
/*!***********************************************************!*\
  !*** ./client/components/make_config/synths/duosynth.vue ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-d65a589c","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../../~/vue-loader/lib/selector?type=styles&index=0!./duosynth.vue */ 228)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./duosynth.vue */ 183),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-d65a589c"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./duosynth.vue */ 292),
  /* scopeId */
  "data-v-d65a589c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 253 */
/* unknown exports provided */
/* exports used: default */
/*!**********************************************************!*\
  !*** ./client/components/make_config/synths/fmsynth.vue ***!
  \**********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-187bd351","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../../~/vue-loader/lib/selector?type=styles&index=0!./fmsynth.vue */ 203)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./fmsynth.vue */ 184),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-187bd351"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./fmsynth.vue */ 267),
  /* scopeId */
  "data-v-187bd351",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/* unknown exports provided */
/* exports used: default */
/*!************************************************************!*\
  !*** ./client/components/make_config/synths/monosynth.vue ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-a9b38896","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../../~/vue-loader/lib/selector?type=styles&index=0!./monosynth.vue */ 226)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./monosynth.vue */ 185),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-a9b38896"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./monosynth.vue */ 290),
  /* scopeId */
  "data-v-a9b38896",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/* unknown exports provided */
/* exports used: default */
/*!********************************************************!*\
  !*** ./client/components/make_config/synths/synth.vue ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-2b043938","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../../~/vue-loader/lib/selector?type=styles&index=0!./synth.vue */ 207)

var Component = __webpack_require__(/*! ../../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../~/vue-loader/lib/selector?type=script&index=0!./synth.vue */ 186),
  /* template */
  __webpack_require__(/*! !../../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2b043938"}!../../../../~/vue-loader/lib/selector?type=template&index=0!./synth.vue */ 271),
  /* scopeId */
  "data-v-2b043938",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 256 */
/* unknown exports provided */
/* exports used: default */
/*!********************************************************!*\
  !*** ./client/components/make_config/video_config.vue ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-16d08bda","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../~/vue-loader/lib/selector?type=styles&index=0!./video_config.vue */ 201)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./video_config.vue */ 188),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-16d08bda"}!../../../~/vue-loader/lib/selector?type=template&index=0!./video_config.vue */ 265),
  /* scopeId */
  "data-v-16d08bda",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/* unknown exports provided */
/* exports used: default */
/*!*************************************************!*\
  !*** ./client/components/player/mountsynth.vue ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-2c86c02e","scoped":true,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector?type=styles&index=0!./mountsynth.vue */ 210)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./mountsynth.vue */ 190),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-2c86c02e"}!../../../~/vue-loader/lib/selector?type=template&index=0!./mountsynth.vue */ 274),
  /* scopeId */
  "data-v-2c86c02e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/* unknown exports provided */
/* exports used: default */
/*!************************************************!*\
  !*** ./client/components/player/titlecard.vue ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-5850d632","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../~/vue-loader/lib/selector?type=styles&index=0!./titlecard.vue */ 215)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./titlecard.vue */ 193),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-5850d632"}!../../../~/vue-loader/lib/selector?type=template&index=0!./titlecard.vue */ 279),
  /* scopeId */
  "data-v-5850d632",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/* unknown exports provided */
/* exports used: default */
/*!****************************************************!*\
  !*** ./client/components/u3c/newsletterSignup.vue ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-1d0c6c33","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../~/vue-loader/lib/selector?type=styles&index=0!./newsletterSignup.vue */ 205)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./newsletterSignup.vue */ 194),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1d0c6c33"}!../../../~/vue-loader/lib/selector?type=template&index=0!./newsletterSignup.vue */ 269),
  /* scopeId */
  "data-v-1d0c6c33",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/* unknown exports provided */
/* exports used: default */
/*!***************************************!*\
  !*** ./client/components/u3c/u3c.vue ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-3d9aea9a","scoped":true,"hasInlineConfig":false}!../../../~/vue-loader/lib/selector?type=styles&index=0!./u3c.vue */ 212)

var Component = __webpack_require__(/*! ../../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../~/vue-loader/lib/selector?type=script&index=0!./u3c.vue */ 195),
  /* template */
  __webpack_require__(/*! !../../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-3d9aea9a"}!../../../~/vue-loader/lib/selector?type=template&index=0!./u3c.vue */ 276),
  /* scopeId */
  "data-v-3d9aea9a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */
/* unknown exports provided */
/* exports used: default */
/*!******************************!*\
  !*** ./client/views/All.vue ***!
  \******************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-1812243f","scoped":true,"hasInlineConfig":false}!../../~/vue-loader/lib/selector?type=styles&index=0!./All.vue */ 202)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./All.vue */ 196),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1812243f"}!../../~/vue-loader/lib/selector?type=template&index=0!./All.vue */ 266),
  /* scopeId */
  "data-v-1812243f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************!*\
  !*** ./client/views/Home.vue ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-64a88031","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../~/vue-loader/lib/selector?type=styles&index=0!./Home.vue */ 219)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Home.vue */ 197),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-64a88031"}!../../~/vue-loader/lib/selector?type=template&index=0!./Home.vue */ 283),
  /* scopeId */
  "data-v-64a88031",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/* unknown exports provided */
/* exports used: default */
/*!*******************************!*\
  !*** ./client/views/Make.vue ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-f7e51c80","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../~/vue-loader/lib/selector?type=styles&index=0!./Make.vue */ 229)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Make.vue */ 198),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-f7e51c80"}!../../~/vue-loader/lib/selector?type=template&index=0!./Make.vue */ 293),
  /* scopeId */
  "data-v-f7e51c80",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/* unknown exports provided */
/* exports used: default */
/*!*********************************!*\
  !*** ./client/views/Single.vue ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../~/vue-loader/lib/style-compiler/index?{"id":"data-v-1c810c9a","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../~/vue-loader/lib/selector?type=styles&index=0!./Single.vue */ 204)

var Component = __webpack_require__(/*! ../../~/vue-loader/lib/component-normalizer */ 2)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../~/vue-loader/lib/selector?type=script&index=0!./Single.vue */ 199),
  /* template */
  __webpack_require__(/*! !../../~/vue-loader/lib/template-compiler/index?{"id":"data-v-1c810c9a"}!../../~/vue-loader/lib/selector?type=template&index=0!./Single.vue */ 268),
  /* scopeId */
  "data-v-1c810c9a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 265 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-16d08bda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/video_config.vue ***!
  \***************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('background-video'), _vm._v(" "), _c('div', {
    staticClass: "config"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "configPanel"
  }, [_c('label', [_vm._v("Curated Video")]), _vm._v(" "), _c('select', {
    on: {
      "change": _vm.videoSelect
    }
  }, _vm._l((_vm.videoList), function(video) {
    return _c('option', {
      domProps: {
        "value": video.id
      }
    }, [_vm._v(_vm._s(video.title))])
  })), _vm._v(" "), _c('label', [_vm._v("Custom YouTube Video (paste part after ?v= in url)")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.background.id
    },
    on: {
      "change": function($event) {
        _vm.update($event.target.value, 'videoId')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Start Time")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.background.params.start
    },
    on: {
      "change": function($event) {
        _vm.update($event.target.value, 'params', 'start')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("End Time")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.background.params.end
    },
    on: {
      "change": function($event) {
        _vm.update($event.target.value, 'params', 'end')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Volume")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.background.params.volume
    },
    on: {
      "change": function($event) {
        _vm.update($event.target.value, 'params', 'volume')
      }
    }
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "sectionHeader"
  }, [_c('span', [_vm._v("video")])])
}]}

/***/ }),
/* 266 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1812243f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/All.vue ***!
  \*************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('h1', [_vm._v("All Music Boxes")]), _vm._v(" "), _vm._l((_vm.musicBoxes), function(box, key) {
    return _c('div', [_c('h4', [_c('router-link', {
      attrs: {
        "to": {
          path: 'musicboxes',
          query: {
            id: box['.key']
          }
        }
      }
    }, [_vm._v(_vm._s(box.meta.title))])], 1), _vm._v(" "), _c('h6', [_vm._v(_vm._s(box.meta.creator))])])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 267 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-187bd351"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/synths/fmsynth.vue ***!
  \*****************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "synthConfig"
  }, [_c('div', {
    staticClass: "category"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('label', [_vm._v("Oscillator")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.oscillator.type
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'oscillator', 'type')
      }
    }
  }, _vm._l((_vm.options.oscillators.standard), function(oscillator) {
    return _c('option', [_vm._v(_vm._s(oscillator))])
  })), _vm._v(" "), _c('label', [_vm._v("Modulation Oscillator")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.modulation.type
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulation', 'type')
      }
    }
  }, _vm._l((_vm.options.oscillators.standard), function(oscillator) {
    return _c('option', [_vm._v(_vm._s(oscillator))])
  })), _vm._v(" "), _c('label', [_vm._v("Volume")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "-50",
      "max": "0"
    },
    domProps: {
      "value": _vm.config.volume
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'volume')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.volume
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'volume')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Harmonicity")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "20"
    },
    domProps: {
      "value": _vm.config.harmonicity
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'harmonicity')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.harmonicity
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'harmonicity')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Modulation Index")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "50"
    },
    domProps: {
      "value": _vm.config.modulationIndex
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationIndex')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.modulationIndex
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationIndex')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Detune")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "-200",
      "max": "200"
    },
    domProps: {
      "value": _vm.config.detune
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'detune')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.detune
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'detune')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('label', [_vm._v("Attack")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.envelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Attack Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.envelope.attackCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'attackCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  })), _vm._v(" "), _c('label', [_vm._v("Decay")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.envelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Sustain")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.envelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.envelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'release')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'release')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.envelope.releaseCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'releaseCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('label', [_vm._v("Attack")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Attack Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.modulationEnvelope.attackCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'attackCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  })), _vm._v(" "), _c('label', [_vm._v("Decay")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Sustain")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'release')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'release')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.modulationEnvelope.releaseCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'releaseCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Synth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Envelope")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Modulation Envelope")])])
}]}

/***/ }),
/* 268 */
/* unknown exports provided */
/* all exports used */
/*!****************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c810c9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Single.vue ***!
  \****************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "player"
    }
  }, [(!_vm.userStart) ? _c('div', [(_vm.boxConfig.meta) ? _c('h1', [_vm._v(_vm._s(_vm.$store.state.meta.title))]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Lower octave: 'Q', 'W', 'E', 'R', 'T'")]), _vm._v(" "), _c('h3', [_vm._v("Upper octave: 'H', 'J', 'K', 'L', ';'")]), _vm._v(" "), _c('h4', [_vm._v("composition lasts " + _vm._s(_vm.$store.state.meta.length) + " seconds")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$store.state.meta.intro))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.start
    }
  }, [_vm._v("Start")])]) : _vm._e(), _vm._v(" "), (_vm.userStart) ? _c('div', [_c('player', {
    on: {
      "ended": _vm.ended
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.userStart) ? _c('u3c', {
    attrs: {
      "config": this.u3c
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 269 */
/* unknown exports provided */
/* all exports used */
/*!***********************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d0c6c33"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/u3c/newsletterSignup.vue ***!
  \***********************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.active) ? _c('div', {
    staticClass: "signupContainer"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.active = false
      }
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('p', [_vm._v("Want to infrequently hear about new musicboxes and other UCC projects? Add your email below")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('button', {
    on: {
      "click": _vm.newsletterSignup
    }
  }, [_vm._v("Sign Up")])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 270 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2340cccc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/player/overlay.vue ***!
  \*****************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.layout), function(octave) {
    return _c('div', {
      staticClass: "bands",
      style: (octave.config)
    }, _vm._l((octave.bands), function(band, index) {
      return _c('div', {
        style: ([band.base, _vm.active[band.index] ? band.transitionIn : band.transitionOut])
      })
    }))
  }))
},staticRenderFns: []}

/***/ }),
/* 271 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b043938"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/synths/synth.vue ***!
  \***************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "synthConfig"
  }, [_c('div', {
    staticClass: "category"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('label', [_vm._v("Oscillator")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.oscillator.type
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'oscillator', 'type')
      }
    }
  }, _vm._l((_vm.options.oscillators.standard), function(oscillator) {
    return _c('option', [_vm._v(_vm._s(oscillator))])
  })), _vm._v(" "), _c('label', [_vm._v("Volume")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "-50",
      "max": "0"
    },
    domProps: {
      "value": _vm.config.volume
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'volume')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.volume
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'volume')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Detune")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "-200",
      "max": "200"
    },
    domProps: {
      "value": _vm.config.detune
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'detune')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.detune
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'detune')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('label', [_vm._v("Attack")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.envelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Attack Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.envelope.attackCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'attackCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  })), _vm._v(" "), _c('label', [_vm._v("Decay")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.envelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Sustain")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.envelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.envelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'release')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'release')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.envelope.releaseCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'releaseCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Synth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Envelope")])])
}]}

/***/ }),
/* 272 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b07e718"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/meta_config.vue ***!
  \**************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "setParams"
    }
  }, [_c('div', {
    staticClass: "olpInput"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.meta.title
    },
    on: {
      "change": function($event) {
        _vm.update('title', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "olpInput"
  }, [_c('label', [_vm._v("Intro Text")]), _vm._v(" "), _c('textarea', {
    domProps: {
      "value": _vm.meta.intro
    },
    on: {
      "change": function($event) {
        _vm.update('intro', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "olpInput"
  }, [_c('label', [_vm._v("Creator")]), _vm._v(" "), _c('input', {
    staticClass: "olpInput",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.meta.creator
    },
    on: {
      "change": function($event) {
        _vm.update('creator', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "olpInput"
  }, [_c('label', [_vm._v("Duration")]), _vm._v(" "), _c('input', {
    staticClass: "olpInput",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.meta.length
    },
    on: {
      "change": function($event) {
        _vm.update('length', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("Publish")])]), _vm._v(" "), _c('u3c', {
    attrs: {
      "config": this.u3c
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "sectionHeader"
  }, [_c('span', [_vm._v("meta")])])
}]}

/***/ }),
/* 273 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bfc60aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/scale_config.vue ***!
  \***************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_vm._m(0), _vm._v(" "), _c('div', [_c('label', [_vm._v("Select Scale")]), _vm._v(" "), _c('select', {
    on: {
      "change": _vm.updateScale
    }
  }, _vm._l((_vm.scales), function(scale) {
    return _c('option', {
      domProps: {
        "value": scale.id
      }
    }, [_vm._v(_vm._s(scale.name))])
  }))]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Key:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.key),
      expression: "key"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.key = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.scaleConfig.possibleNotes), function(note) {
    return _c('option', [_vm._v(_vm._s(note))])
  })), _vm._v(" "), _c('label', [_vm._v("Octave 1")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.octave1),
      expression: "octave1"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.octave1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.scaleConfig.possibleOctaves), function(octave) {
    return _c('option', [_vm._v(_vm._s(octave))])
  })), _vm._v(" "), _c('label', [_vm._v("Octave 2")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.octave2),
      expression: "octave2"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.octave2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.scaleConfig.possibleOctaves), function(octave) {
    return _c('option', [_vm._v(_vm._s(octave))])
  }))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "triggerContainer"
    }
  }, _vm._l((_vm.active_scale), function(pitch, index) {
    return _c('synth-trigger', {
      key: index,
      attrs: {
        "config": pitch,
        "playing": _vm.playing[index]
      }
    })
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "sectionHeader"
  }, [_c('span', [_vm._v("scale")])])
}]}

/***/ }),
/* 274 */
/* unknown exports provided */
/* all exports used */
/*!********************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c86c02e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/player/mountsynth.vue ***!
  \********************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 275 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-3004558c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/synths/amsynth.vue ***!
  \*****************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "synthConfig"
  }, [_c('div', {
    staticClass: "category"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('label', [_vm._v("Oscillator")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.oscillator.type
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'oscillator', 'type')
      }
    }
  }, _vm._l((_vm.options.oscillators.standard), function(oscillator) {
    return _c('option', [_vm._v(_vm._s(oscillator))])
  })), _vm._v(" "), _c('label', [_vm._v("Modulation Oscillator")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.modulation.type
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulation', 'type')
      }
    }
  }, _vm._l((_vm.options.oscillators.standard), function(oscillator) {
    return _c('option', [_vm._v(_vm._s(oscillator))])
  })), _vm._v(" "), _c('label', [_vm._v("Volume")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "-50",
      "max": "0"
    },
    domProps: {
      "value": _vm.config.volume
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'volume')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.volume
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'volume')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Harmonicity")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "20"
    },
    domProps: {
      "value": _vm.config.harmonicity
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'harmonicity')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.harmonicity
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'harmonicity')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Detune")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "-200",
      "max": "200"
    },
    domProps: {
      "value": _vm.config.detune
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'detune')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.detune
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'detune')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('label', [_vm._v("Attack")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": ".1"
    },
    domProps: {
      "value": _vm.config.envelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Attack Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.envelope.attackCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'attackCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  })), _vm._v(" "), _c('label', [_vm._v("Decay")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": ".1"
    },
    domProps: {
      "value": _vm.config.envelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Sustain")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": ".1"
    },
    domProps: {
      "value": _vm.config.envelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": ".1"
    },
    domProps: {
      "value": _vm.config.envelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'release')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'release')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.envelope.releaseCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'releaseCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('label', [_vm._v("Attack")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": ".1"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Attack Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.modulationEnvelope.attackCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'attackCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  })), _vm._v(" "), _c('label', [_vm._v("Decay")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": ".1"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Sustain")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": ".1"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": ".1"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'release')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.modulationEnvelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'release')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.modulationEnvelope.releaseCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'modulationEnvelope', 'releaseCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Synth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Envelope")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Modulation Envelope")])])
}]}

/***/ }),
/* 276 */
/* unknown exports provided */
/* all exports used */
/*!**********************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d9aea9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/u3c/u3c.vue ***!
  \**********************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.explainer) ? _c('div', {
    staticClass: "explainer"
  }, [_vm._v("The Under Construction Club is a bunch of half-finished, undesigned projects released too early. Click the button for more info on this page or head to the site itself by clicking the name.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "topBanner"
  }, [_c('div', {
    staticClass: "bannerOverlay"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "http://www.under-construction.club"
    },
    on: {
      "mouseenter": function($event) {
        _vm.explainer = true
      },
      "mouseleave": function($event) {
        _vm.explainer = false
      }
    }
  }, [_vm._v("\n          Under Construction Club\n        ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.min = !_vm.min
      }
    }
  }, [(_vm.min) ? _c('span', [_vm._v("+")]) : _c('span', [_vm._v("-")])])])])]), _vm._v(" "), (!_vm.min) ? _c('div', {
    staticClass: "textBox"
  }, [(_vm.state === 'text') ? _c('div', [_c('button', {
    on: {
      "click": function($event) {
        _vm.state = 'guestbook'
      }
    }
  }, [_vm._v("Guestbook")]), _vm._v(" "), (_vm.config.about) ? _c('div', [_c('label', [_vm._v("About")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.config.about))])]) : _vm._e(), _vm._v(" "), (_vm.config.instructions) ? _c('div', [_c('label', [_vm._v("Instructions")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.config.instructions))])]) : _vm._e(), _vm._v(" "), (_vm.config.next) ? _c('div', [_c('label', [_vm._v("How Can I help?")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.config.next))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.state === 'guestbook') ? _c('div', [_c('button', {
    on: {
      "click": function($event) {
        _vm.state = 'text'
      }
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newComment),
      expression: "newComment"
    }],
    domProps: {
      "value": (_vm.newComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newComment = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": !_vm.newComment
    },
    on: {
      "click": _vm.post
    }
  }, [_vm._v("Post")]), _vm._v(" "), (_vm.comments) ? _c('div', [_c('label', [_vm._v("Suggestion Box/Guestbook")]), _vm._v(" "), _vm._l((_vm.comments), function(comment) {
    return _c('p', [_vm._v(_vm._s(comment.text))])
  })], 2) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 277 */
/* unknown exports provided */
/* all exports used */
/*!*************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e33ae52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/player/backgroundvideo.vue ***!
  \*************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "video-background"
  }, [_c('div', {
    staticClass: "video-foreground"
  }, [_c('youtube', {
    attrs: {
      "id": "video",
      "videoId": _vm.video.videoId,
      "player-width": "100%",
      "player-height": "100%",
      "player-vars": {
        start: _vm.video.params.start,
        end: _vm.video.params.end,
        autoplay: 1,
        disabled: 1,
        showinfo: 0,
        modestbranding: 1,
        playlist: _vm.video.videoId,
        loop: 1,
        controls: 0
      }
    },
    on: {
      "ready": _vm.ready
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 278 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f1655e5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/overlay_config.vue ***!
  \*****************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('section', [_vm._m(0), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.randomize('shallow')
      }
    }
  }, [_vm._v("Randomize")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.randomize('deep')
      }
    }
  }, [_vm._v("Deep Randomize")]), _vm._v(" "), _vm._l((_vm.colorConfig), function(octave, index) {
    return _c('div', [_c('div', {
      staticClass: "octaveConfig"
    }, [_c('h2', [_vm._v(_vm._s(octave.name))]), _vm._v(" "), _c('label', [_vm._v("Direction")]), _vm._v(" "), _c('select', {
      domProps: {
        "value": octave.config['flex-direction']
      },
      on: {
        "change": function($event) {
          _vm.updateGroup(index, 'flex-direction', $event.target.value)
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "column"
      }
    }, [_vm._v("Column")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "row"
      }
    }, [_vm._v("Row")])]), _vm._v(" "), _c('select', {
      domProps: {
        "value": octave.config['display']
      },
      on: {
        "change": function($event) {
          _vm.updateGroup(index, 'display', $event.target.value)
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "flex"
      }
    }, [_vm._v("Show [display: flex]")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "none"
      }
    }, [_vm._v("Hide")])]), _vm._v(" "), _vm._l((octave.styles), function(band) {
      return _c('div', [_c('label', [_vm._v("Color")]), _vm._v(" "), _c('input', {
        attrs: {
          "type": "color"
        },
        domProps: {
          "value": band.color
        },
        on: {
          "change": function($event) {
            _vm.updateBand(band.id, index, 'color', $event.target.value)
          }
        }
      }), _vm._v(" "), _c('label', [_vm._v("Grow")]), _vm._v(" "), _c('input', {
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": band.grow
        },
        on: {
          "change": function($event) {
            _vm.updateBand(band.id, index, 'grow', $event.target.value)
          }
        }
      }), _vm._v(" "), _c('label', [_vm._v("Offset Top")]), _vm._v(" "), _c('input', {
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": band.offsetTop
        },
        on: {
          "change": function($event) {
            _vm.updateBand(band.id, index, 'offsetTop', $event.target.value)
          }
        }
      }), _vm._v(" "), _c('label', [_vm._v("Offset Left")]), _vm._v(" "), _c('input', {
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": band.offsetLeft
        },
        on: {
          "change": function($event) {
            _vm.updateBand(band.id, index, 'offsetLeft', $event.target.value)
          }
        }
      }), _vm._v(" "), _c('label', [_vm._v("Start Opacity")]), _vm._v(" "), _c('input', {
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": band.startOpacity
        },
        on: {
          "change": function($event) {
            _vm.updateBand(band.id, index, 'startOpacity', $event.target.value)
          }
        }
      }), _vm._v(" "), _c('label', [_vm._v("End Opacity")]), _vm._v(" "), _c('input', {
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": band.endOpacity
        },
        on: {
          "change": function($event) {
            _vm.updateBand(band.id, index, 'endOpacity', $event.target.value)
          }
        }
      })])
    })], 2)])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "sectionHeader"
  }, [_c('span', [_vm._v("overlay")])])
}]}

/***/ }),
/* 279 */
/* unknown exports provided */
/* all exports used */
/*!*******************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-5850d632"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/player/titlecard.vue ***!
  \*******************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('main', [_c('h1', [_vm._v(_vm._s(_vm.card.title))]), _vm._v(" "), _c('h4', [_vm._v("[" + _vm._s(_vm.card.creator) + "]")])])])
},staticRenderFns: []}

/***/ }),
/* 280 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-5abb859b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/effects/tremolo.vue ***!
  \******************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('label', [_vm._v("Frequency")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "20",
      "step": "0.5"
    },
    domProps: {
      "value": _vm.effectConfig.frequency
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'frequency', 'Tremolo')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.effectConfig.frequency
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'frequency', 'Tremolo')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Depth")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.effectConfig.depth
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'depth', 'Tremolo')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Spread")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "600",
      "step": "50"
    },
    domProps: {
      "value": _vm.effectConfig.spread
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'spread', 'Tremolo')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Wet")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.effectConfig.wet
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'wet', 'Tremolo')
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 281 */
/* unknown exports provided */
/* all exports used */
/*!*******************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b91e14c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/effects/freeverb.vue ***!
  \*******************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('label', [_vm._v("Room Size")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": ".9",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.effectConfig.roomSize
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'roomSize', 'Freeverb')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Dampening")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5000",
      "step": "50"
    },
    domProps: {
      "value": _vm.effectConfig.dampening
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'dampening', 'Freeverb')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Wet")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.effectConfig.wet
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'wet', 'Freeverb')
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 282 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-61980bc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/effects/vibrato.vue ***!
  \******************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('label', [_vm._v("Frequency")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "10",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.effectConfig.frequency
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'frequency', 'Vibrato')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.effectConfig.frequency
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'frequency', 'Vibrato')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Depth")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.effectConfig.depth
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'depth', 'Vibrato')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Wet")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.effectConfig.wet
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'wet', 'Vibrato')
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 283 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-64a88031"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue ***!
  \**************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "player"
    }
  }, [(!_vm.userStart) ? _c('div', [(_vm.boxConfig.meta) ? _c('h1', [_vm._v(_vm._s(_vm.$store.state.meta.title))]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Lower octave: 'Q', 'W', 'E', 'R', 'T'")]), _vm._v(" "), _c('h3', [_vm._v("Upper octave: 'H', 'J', 'K', 'L', ';'")]), _vm._v(" "), _c('h4', [_vm._v("composition lasts " + _vm._s(_vm.$store.state.meta.length) + " seconds")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$store.state.meta.intro))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.start
    }
  }, [_vm._v("Start")]), _vm._v(" "), _c('label', {
    attrs: {
      "id": "new"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/make"
    }
  }, [_vm._v("Make A New One")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.userStart) ? _c('div', [_c('player', {
    on: {
      "ended": _vm.ended
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.userStart) ? _c('u3c', {
    attrs: {
      "config": this.u3c
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 284 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-672959f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/mutation_config.vue ***!
  \******************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('h3', [_vm._v("Single Play Music Box")]), _vm._v(" "), _c('p', [_vm._v("If you don't know what these are I suggest not touching them other than turning them on or off. V v much a work in progress. See the Under Construction Club widget for more.")]), _vm._v(" "), _c('p', [_vm._v("Interval input sets the interval at which compounding effects are applied (i.e. in 'volumeDown' volume decreases by one every eight seconds)")]), _vm._v(" "), _vm._l((_vm.mutations), function(mutation, index) {
    return _c('div', [_c('h4', [_vm._v(_vm._s(mutation.type))]), _vm._v(" "), _c('label', [_vm._v("Active")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (mutation.active),
        expression: "mutation.active"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(mutation.active) ? _vm._i(mutation.active, null) > -1 : (mutation.active)
      },
      on: {
        "change": function($event) {
          var $$a = mutation.active,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (mutation.active = $$a.concat([$$v]))
            } else {
              $$i > -1 && (mutation.active = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(mutation, "active", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', [_vm._v("Start")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (mutation.start),
        expression: "mutation.start"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (mutation.start)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(mutation, "start", $event.target.value)
        }
      }
    }), _vm._v(" "), (mutation.interval) ? _c('span', [_c('label', [_vm._v("Additional Effect Interval")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (mutation.interval),
        expression: "mutation.interval"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (mutation.interval)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(mutation, "interval", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('pre', [_vm._v(_vm._s(mutation))])])
  }), _vm._v(" "), _c('h3', [_vm._v("Generative Music Box")]), _vm._v(" "), _c('p', [_vm._v("Eventually this thing will let you set multiple short loops with different synth that will play and evolve (note changes, duration changes, phasing, etc) over time. You'll be able to set the rules here")]), _vm._v(" "), _c('u3c', {
    attrs: {
      "config": this.u3c
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 285 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ef47b39"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/App.vue ***!
  \******************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 286 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-77954aef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/synths/triggers.vue ***!
  \******************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("\n  " + _vm._s(_vm.config.note) + " " + _vm._s(_vm.config.octave) + "\n  "), _c('h4', {
    class: {
      'notePlaying': _vm.playing
    }
  }, [_vm._v("\n    " + _vm._s(_vm.config.keyCode) + "\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 287 */
/* unknown exports provided */
/* all exports used */
/*!****************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-78917ac5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/filter_config.vue ***!
  \****************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.configActive
    },
    on: {
      "change": _vm.toggleFilter
    }
  }), _vm._v(" "), (_vm.configActive) ? _c('section', {
    staticClass: "filterConfig"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('label', [_vm._v("Filter Type")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.configValues.type
    },
    on: {
      "change": function($event) {
        _vm.updateVuexFilter($event.target.value, 'type')
      }
    }
  }, _vm._l((_vm.options.filter.allTypes), function(type) {
    return _c('option', [_vm._v(_vm._s(type))])
  })), _vm._v(" "), _c('label', [_vm._v("Frequency")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "20000",
      "step": "100"
    },
    domProps: {
      "value": _vm.configValues.frequency
    },
    on: {
      "change": function($event) {
        _vm.updateVuexFilter($event.target.value, 'frequency')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.configValues.frequency
    },
    on: {
      "change": function($event) {
        _vm.updateVuexFilter($event.target.value, 'frequency')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Q")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "30"
    },
    domProps: {
      "value": _vm.configValues.Q
    },
    on: {
      "change": function($event) {
        _vm.updateVuexFilter($event.target.value, 'Q')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.configValues.Q
    },
    on: {
      "change": function($event) {
        _vm.updateVuexFilter($event.target.value, 'Q')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Rolloff")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.configValues.rolloff
    },
    on: {
      "change": function($event) {
        _vm.updateVuexFilter($event.target.value, 'rolloff')
      }
    }
  }, _vm._l((_vm.options.filter.rollOffValues), function(rolloff) {
    return _c('option', [_vm._v(_vm._s(rolloff))])
  }))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Filter")])])
}]}

/***/ }),
/* 288 */
/* unknown exports provided */
/* all exports used */
/*!*****************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c054627"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/effects/chorus.vue ***!
  \*****************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('label', [_vm._v("Frequency")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "10",
      "step": "0.5"
    },
    domProps: {
      "value": _vm.effectConfig.frequency
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'frequency', 'Chorus')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.effectConfig.frequency
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'frequency', 'Chorus')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Delay Time")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "8"
    },
    domProps: {
      "value": _vm.effectConfig.delayTime
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'delayTime', 'Chorus')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Depth")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.effectConfig.depth
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'depth', 'Chorus')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Feedback")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "0.5",
      "step": "0.05"
    },
    domProps: {
      "value": _vm.effectConfig.feedback
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'feedback', 'Chorus')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Spread")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "600",
      "step": "50"
    },
    domProps: {
      "value": _vm.effectConfig.spread
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'spread', 'Chorus')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Wet")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.effectConfig.wet
    },
    on: {
      "change": function($event) {
        _vm.updateVuexEffect($event.target.value, 'wet', 'Chorus')
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 289 */
/* unknown exports provided */
/* all exports used */
/*!****************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2c2e7f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/player/player.vue ***!
  \****************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.showTitle) ? _c('title-card') : _vm._e(), _vm._v(" "), _c('background-video'), _vm._v(" "), _c('color-filter-overlay', {
    staticClass: "color-filter-overlay",
    attrs: {
      "active": _vm.playing
    }
  }), _vm._v(" "), _c('mount-synth', {
    on: {
      "attackStart": _vm.attackStart,
      "releaseStart": _vm.releaseStart
    }
  }), _vm._v(" "), (_vm.playbackEnded) ? _c('newsletter-signup') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 290 */
/* unknown exports provided */
/* all exports used */
/*!*******************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9b38896"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/synths/monosynth.vue ***!
  \*******************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "synthConfig"
  }, [_c('div', {
    staticClass: "category"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('label', [_vm._v("Oscillator")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.oscillator.type
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'oscillator', 'type')
      }
    }
  }, _vm._l((_vm.options.oscillators.standard), function(oscillator) {
    return _c('option', [_vm._v(_vm._s(oscillator))])
  })), _vm._v(" "), _c('label', [_vm._v("Volume")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "-50",
      "max": "-10"
    },
    domProps: {
      "value": _vm.config.volume
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'volume')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.volume
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'volume')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Detune")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "-200",
      "max": "200"
    },
    domProps: {
      "value": _vm.config.detune
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'detune')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.detune
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'detune')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('label', [_vm._v("Q")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": _vm.config.filter.Q
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'filter', 'Q')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.filter.Q
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'filter', 'Q')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Type")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.filter.type
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'filter', 'type')
      }
    }
  }, _vm._l((_vm.options.filter.allTypes), function(filterType) {
    return _c('option', [_vm._v(_vm._s(filterType))])
  })), _vm._v(" "), _c('label', [_vm._v("Rolloff")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.filter.rolloff
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'filter', 'rolloff')
      }
    }
  }, _vm._l((_vm.options.filter.rollOffValues), function(rolloff) {
    return _c('option', [_vm._v(_vm._s(rolloff))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('label', [_vm._v("Attack")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.envelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Attack Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.envelope.attackCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'attackCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  })), _vm._v(" "), _c('label', [_vm._v("Decay")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.envelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Sustain")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.envelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.envelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'release')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.envelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'release')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.envelope.releaseCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'envelope', 'releaseCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('label', [_vm._v("Attack")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.filterEnvelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'filterEnvelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.filterEnvelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'filterEnvelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Decay")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.filterEnvelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'filterEnvelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.filterEnvelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'filterEnvelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Sustain")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.filterEnvelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'filterEnvelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.filterEnvelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'filterEnvelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.filterEnvelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'filterEnvelope', 'release')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.filterEnvelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'filterEnvelope', 'release')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Base Frequency")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5000"
    },
    domProps: {
      "value": _vm.config.filterEnvelope.baseFrequency
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'filterEnvelope', 'baseFrequency')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.filterEnvelope.baseFrequency
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'filterEnvelope', 'baseFrequency')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Octave")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "20"
    },
    domProps: {
      "value": _vm.config.filterEnvelope.octaves
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'filterEnvelope', 'octaves')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.filterEnvelope.octaves
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'filterEnvelope', 'octaves')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Exponent")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "10"
    },
    domProps: {
      "value": _vm.config.filterEnvelope.exponent
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'filterEnvelope', 'exponent')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.filterEnvelope.exponent
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'filterEnvelope', 'exponent')
      }
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Synth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Filter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Envelope")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Filter Envelope")])])
}]}

/***/ }),
/* 291 */
/* unknown exports provided */
/* all exports used */
/*!***************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3655b0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/synth_config.vue ***!
  \***************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_vm._m(0), _vm._v(" "), _c('section', [_c('select', {
    domProps: {
      "value": _vm.toneConfig.synth
    },
    on: {
      "change": _vm.changeSynth
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Select Synth")]), _vm._v(" "), _vm._l((_vm.possibleSynths), function(synth) {
    return _c('option', [_vm._v(_vm._s(synth))])
  })], 2), _vm._v(" "), (_vm.toneConfig.synth === 'Synth') ? _c('synth') : _vm._e(), _vm._v(" "), (_vm.toneConfig.synth === 'MonoSynth') ? _c('monosynth') : _vm._e(), _vm._v(" "), (_vm.toneConfig.synth === 'AMSynth') ? _c('amsynth') : _vm._e(), _vm._v(" "), (_vm.toneConfig.synth === 'FMSynth') ? _c('fmsynth') : _vm._e(), _vm._v(" "), (_vm.toneConfig.synth === 'DuoSynth') ? _c('duosynth') : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.effectsConfig), function(effect) {
    return _c('div', {
      staticClass: "effectConfig"
    }, [_c('label', [_vm._v(_vm._s(effect.name))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (effect.active),
        expression: "effect.active"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": effect.name,
        "checked": Array.isArray(effect.active) ? _vm._i(effect.active, effect.name) > -1 : (effect.active)
      },
      on: {
        "change": function($event) {
          var $$a = effect.active,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = effect.name,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (effect.active = $$a.concat([$$v]))
            } else {
              $$i > -1 && (effect.active = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(effect, "active", $$c)
          }
        }
      }
    }), _vm._v(" "), (effect.name === 'Chorus' && effect.active) ? _c('chorus') : _vm._e(), _vm._v(" "), (effect.name === 'Tremolo' && effect.active) ? _c('tremolo') : _vm._e(), _vm._v(" "), (effect.name === 'Vibrato' && effect.active) ? _c('vibrato') : _vm._e(), _vm._v(" "), (effect.name === 'Freeverb' && effect.active) ? _c('freeverb') : _vm._e()], 1)
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tonefilter')], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "sectionHeader"
  }, [_c('span', [_vm._v("synth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "sectionHeader"
  }, [_c('span', [_vm._v("effects")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "sectionHeader"
  }, [_c('span', [_vm._v("filter")])])
}]}

/***/ }),
/* 292 */
/* unknown exports provided */
/* all exports used */
/*!******************************************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-d65a589c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/make_config/synths/duosynth.vue ***!
  \******************************************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "duoSynthConfig"
  }, [_c('div', {
    staticClass: "groupControls"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('label', [_vm._v("Vibrato Amount")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "3",
      "step": "0.25"
    },
    domProps: {
      "value": _vm.config.vibratoAmount
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'vibratoAmount')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.vibratoAmount
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'vibratoAmount')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Vibrato Rate")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "20"
    },
    domProps: {
      "value": _vm.config.vibratoRate
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'vibratoRate')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.vibratoRate
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'vibratoRate')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Harmonicity")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "20"
    },
    domProps: {
      "value": _vm.config.harmonicity
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'harmonicity')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.harmonicity
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'harmonicity')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "voice"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "voiceControls"
  }, [_c('div', {
    staticClass: "parentCategory"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_c('label', [_vm._v("Oscillator")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.voice0.oscillator.type
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'oscillator', 'type')
      }
    }
  }, _vm._l((_vm.options.oscillators.standard), function(oscillator) {
    return _c('option', [_vm._v(_vm._s(oscillator))])
  })), _vm._v(" "), _c('label', [_vm._v("Volume")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "-50",
      "max": "0"
    },
    domProps: {
      "value": _vm.config.voice0.volume
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'volume')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice0.volume
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'volume')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Detune")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "-200",
      "max": "200"
    },
    domProps: {
      "value": _vm.config.voice0.detune
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'detune')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice0.detune
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'detune')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "parentCategory"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_c('label', [_vm._v("Attack")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.voice0.envelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'envelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice0.envelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'envelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Attack Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.voice0.envelope.attackCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'envelope', 'attackCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  })), _vm._v(" "), _c('label', [_vm._v("Decay")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.voice0.envelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'envelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice0.envelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'envelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Sustain")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.voice0.envelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'envelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice0.envelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'envelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.voice0.envelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'envelope', 'release')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice0.envelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'envelope', 'release')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.voice0.envelope.releaseCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'envelope', 'releaseCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "parentCategory"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_c('label', [_vm._v("Attack")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.voice0.filterEnvelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'filterEnvelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice0.filterEnvelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'filterEnvelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Attack Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.voice0.filterEnvelope.attackCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'filterEnvelope', 'attackCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  })), _vm._v(" "), _c('label', [_vm._v("Decay")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5"
    },
    domProps: {
      "value": _vm.config.voice0.filterEnvelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'filterEnvelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice0.filterEnvelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'filterEnvelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Sustain")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1"
    },
    domProps: {
      "value": _vm.config.voice0.filterEnvelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'filterEnvelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice0.filterEnvelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'filterEnvelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5"
    },
    domProps: {
      "value": _vm.config.voice0.filterEnvelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'filterEnvelope', 'release')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice0.filterEnvelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'filterEnvelope', 'release')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.voice0.filterEnvelope.releaseCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice0', 'filterEnvelope', 'releaseCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "voice"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "voiceControls"
  }, [_c('div', {
    staticClass: "parentCategory"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_c('label', [_vm._v("Oscillator")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.voice1.oscillator.type
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'oscillator', 'type')
      }
    }
  }, _vm._l((_vm.options.oscillators.standard), function(oscillator) {
    return _c('option', [_vm._v(_vm._s(oscillator))])
  })), _vm._v(" "), _c('label', [_vm._v("Volume")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "-50",
      "max": "0"
    },
    domProps: {
      "value": _vm.config.voice1.volume
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'volume')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice1.volume
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'volume')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Detune")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "-200",
      "max": "200"
    },
    domProps: {
      "value": _vm.config.voice1.detune
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'detune')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice1.detune
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'detune')
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "parentCategory"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_c('label', [_vm._v("Attack")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.voice1.envelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'envelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice1.envelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'envelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Attack Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.voice1.envelope.attackCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'envelope', 'attackCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  })), _vm._v(" "), _c('label', [_vm._v("Decay")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.voice1.envelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'envelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice1.envelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'envelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Sustain")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.voice1.envelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'envelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice1.envelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'envelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.voice1.envelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'envelope', 'release')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice1.envelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'envelope', 'release')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.voice1.envelope.releaseCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'envelope', 'releaseCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "parentCategory"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_c('label', [_vm._v("Attack")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5",
      "step": "0.1"
    },
    domProps: {
      "value": _vm.config.voice1.filterEnvelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'filterEnvelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice1.filterEnvelope.attack
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'filterEnvelope', 'attack')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Attack Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.voice1.filterEnvelope.attackCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'filterEnvelope', 'attackCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  })), _vm._v(" "), _c('label', [_vm._v("Decay")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5"
    },
    domProps: {
      "value": _vm.config.voice1.filterEnvelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'filterEnvelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice1.filterEnvelope.decay
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'filterEnvelope', 'decay')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Sustain")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1"
    },
    domProps: {
      "value": _vm.config.voice1.filterEnvelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'filterEnvelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice1.filterEnvelope.sustain
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'filterEnvelope', 'sustain')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "range",
      "min": "0",
      "max": "5"
    },
    domProps: {
      "value": _vm.config.voice1.filterEnvelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'filterEnvelope', 'release')
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": _vm.config.voice1.filterEnvelope.release
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'filterEnvelope', 'release')
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Release Curve")]), _vm._v(" "), _c('select', {
    domProps: {
      "value": _vm.config.voice1.filterEnvelope.releaseCurve
    },
    on: {
      "change": function($event) {
        _vm.updateVuexSynth($event.target.value, 'voice1', 'filterEnvelope', 'releaseCurve')
      }
    }
  }, _vm._l((_vm.options.envelopeCurves), function(curve) {
    return _c('option', [_vm._v(_vm._s(curve))])
  }))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "voiceTitle"
  }, [_c('h4', [_vm._v("Group Controls")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "voiceTitle"
  }, [_c('h4', [_vm._v("Voice 1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Synth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Envelope")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Filter Envelope")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "voiceTitle"
  }, [_c('h4', [_vm._v("Voice 2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Synth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Envelope")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h4', [_vm._v("Filter Envelope")])])
}]}

/***/ }),
/* 293 */
/* unknown exports provided */
/* all exports used */
/*!**************************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7e51c80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Make.vue ***!
  \**************************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [(_vm.activeView !== 'video' && _vm.showVideo) ? _c('background-video') : _vm._e(), _vm._v(" "), (_vm.showOverlay) ? _c('color-filter-overlay', {
    staticClass: "overlay--make",
    attrs: {
      "active": _vm.playing
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "controlButtons"
  }, [_c('label', [_vm._v("Show (only applies to this page):")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showVideo = !_vm.showVideo
      }
    }
  }, [_vm._v("Video: " + _vm._s(_vm.showVideo))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showOverlay = !_vm.showOverlay
      }
    }
  }, [_vm._v("Overlay: " + _vm._s(_vm.showOverlay))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.showConfig = !_vm.showConfig
      }
    }
  }, [_vm._v("Controls: " + _vm._s(_vm.showConfig))])]), _vm._v(" "), _c('nav', [_c('label', [_vm._v("Create Controls")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.activeView = 'meta'
      }
    }
  }, [_vm._v("Publish Options")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.activeView = 'synth'
      }
    }
  }, [_vm._v("Synth")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.activeView = 'scale'
      }
    }
  }, [_vm._v("Scale")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.activeView = 'video'
      }
    }
  }, [_vm._v("Background Video")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.activeView = 'overlay'
      }
    }
  }, [_vm._v("Overlay")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.activeView = 'mutations'
      }
    }
  }, [_vm._v("Mutations")])]), _vm._v(" "), (_vm.activeView === 'meta' && _vm.showConfig) ? _c('meta-config') : _vm._e(), _vm._v(" "), (_vm.activeView === 'synth' && _vm.showConfig) ? _c('synth-config') : _vm._e(), _vm._v(" "), (_vm.activeView === 'scale' && _vm.showConfig) ? _c('scale-config', {
    attrs: {
      "playing": _vm.playing
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeView === 'video' && _vm.showConfig) ? _c('video-config') : _vm._e(), _vm._v(" "), (_vm.activeView === 'overlay' && _vm.showConfig) ? _c('overlay-config') : _vm._e(), _vm._v(" "), (_vm.activeView === 'mutations' && _vm.showConfig) ? _c('mutation-config') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */
/* unknown exports provided */
/* all exports used */
/*!*************************!*\
  !*** ./client/index.js ***!
  \*************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__promise_polyfill__ = __webpack_require__(/*! ./promise-polyfill */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(/*! ./app */ 91);



// Enable progressive web app support (with offline-plugin)
if (true) {
  __webpack_require__(/*! ./pwa */ 93);
}

__WEBPACK_IMPORTED_MODULE_1__app__["a" /* app */].$mount('#app');

/***/ })
],[300]);


// WEBPACK FOOTER //
// client.94897314.js